var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 733.332,
    height: 442.68,
    viewBox: "0 0 733.332 442.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 447.394)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5 40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.913-372.564h33.2v-16.6h-33.2Z",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.542-372.564h33.2v-16.6h-33.2Z",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.418-393.592h33.2v-16.6h-33.2Z",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.047-393.592h33.2v-16.6h-33.2Z",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.069-462.491h33.2v-16.6h-33.2Z",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.783-330.507H375.542v-16.6h29.069c-2.321.824-4.835,1.591-7.359,2.616a19.08,19.08,0,0,0-11.289,13.177q-.082.4-.18.808",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.284-263.229h-23.9v-16.6h33.2v16.365h-9.3v.236",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.751-221.173H29.386v-16.6h33.2v12.52a3.045,3.045,0,0,0-1.089,1.843,4.255,4.255,0,0,0,.251,2.239",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.557-179.15h33.2v-16.6h-33.2Z",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.172-372.564h33.2v-16.6h-33.2Z",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.51-351.535H393.25v-16.6h33.2v8.481c-5.083,1.991-11.353,4.82-13.236,7.288a10.624,10.624,0,0,1-.708.832",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.068-401.083h33.2v-16.6h-33.2Z",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.318-329.965h23.014v-16.6H710.318Z",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.073-239.826H670.1c-2.421-3.891-4.061-6.381-4.061-6.381q.4,3.306.9,6.381H665.3c-.211-4.763-.417-8.129-.58-9.26-.521-3.636-5.773-5.876-11.784-7.341h18.149c.109,5.945.469,11.491.991,16.6",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.785-197.769H666.31c-.031-5.413-.112-11.083-.227-16.6h7.7v16.6",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.413-239.826H697.881c-.121-5.283-.264-10.861-.431-16.6h13.963v16.6",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.132-455.018h33.2v-16.6h-33.2Z",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.162-218.8h-6.177c-.144-6.047-.323-11.772-.507-16.6h2.256a124.112,124.112,0,0,0,4.428,16.6",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.615-371.2H77.836c-.247-5.289-.594-11.133-1.078-16.6H99.615v16.6m-30.75-8.188c-.795-2.1-1.631-4.128-2.453-6.009v-2.4h3.771c-.5,2.664-.964,5.505-1.318,8.413",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.615-329.143H80.25l2.735-16.6h16.63v16.6m-32.082,0H66.412v-5.631l1.121,5.631",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.043-371.2h33.2v-16.6h-33.2Z",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-470.792H12.784v-16.6H0Z",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4-322.645h33.2v-16.6H206.4Z",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4-280.587h33.2v-16.6H206.4Z",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.639-322.645H244.029v-16.6h13.58c-.691,1.536-1.617,3.184-2.5,5.185a10.934,10.934,0,0,0-.852,4.428,20.878,20.878,0,0,0,1.381,6.989",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.181-301.617H224.107v-16.6h30.324c-1.581,5.268-2.805,10.263-3.579,13.641-.119.523-.331,1.567-.592,2.908a.832.832,0,0,0-.08.052",
    fill: "#8fb8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.988-115.825c-15.2,0-27.523-2.621-27.523-5.856,0-2.624,8.112-4.844,19.292-5.59l.525,4.739h17.032l.424-4.627c10.388.837,17.773,2.973,17.773,5.478,0,3.234-12.323,5.856-27.524,5.856",
    fill: "#6391e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.98-116.43c-30.07-.147-54.231-5.38-54.231-11.814,0-6.524,24.864-11.814,55.537-11.814q1.455,0,2.891.016-.268.882-.536,1.823H44.778v9.845H68.349A87.649,87.649,0,0,0,66.98-116.43m44.926-4.5c-.119-2.83-.215-5.384-.271-7.445h2.407v-6.567c6.168,1.9,9.781,4.211,9.781,6.7,0,2.763-4.454,5.3-11.917,7.315",
    fill: "#6391e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.782-257.99H683.453V-436.312H453.782Z",
    fill: "#c4dbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.105-296.334l-16.191-6.419,6.417-16.191,16.192,6.417L656.1-296.334",
    fill: "#f1eef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.685-425.983H445.55a3.642,3.642,0,0,1-3.643-3.643v-6.8a3.642,3.642,0,0,1,3.643-3.643H691.685a3.643,3.643,0,0,1,3.643,3.643v6.8a3.643,3.643,0,0,1-3.643,3.643",
    fill: "#76a3e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.708-390.736h-23.7v-26.957h23.7v26.957",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.6-411.568H639.112v-1.379H656.6v1.379",
    fill: "#f1eef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.6-407.787H639.112v-1.379H656.6v1.379",
    fill: "#f1eef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.6-404.006H639.112v-1.379H656.6v1.379",
    fill: "#f1eef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.6-400.224H639.112V-401.6H656.6v1.379",
    fill: "#f1eef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.6-396.443H639.112v-1.379H656.6v1.379",
    fill: "#f1eef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.929-415.5a1.072,1.072,0,0,1-1.071,1.072,1.072,1.072,0,0,1-1.072-1.072,1.071,1.071,0,0,1,1.072-1.071,1.071,1.071,0,0,1,1.071,1.071",
    fill: "#d1213d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.12-291.342l-23.495-3.115,3.543-26.723,23.495,3.115-3.543,26.723",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.781-312.4l-17.341-2.3.181-1.365,17.341,2.3-.181,1.365",
    fill: "#f1eef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.284-308.653l-17.341-2.3.181-1.367,17.341,2.3-.181,1.367",
    fill: "#f1eef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.786-304.9l-17.34-2.3.181-1.367,17.341,2.3-.183,1.367",
    fill: "#f1eef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.29-301.155l-17.341-2.3.181-1.367,17.34,2.3-.18,1.367",
    fill: "#f1eef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.793-297.407l-17.341-2.3.181-1.367,17.34,2.3-.18,1.367",
    fill: "#f1eef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.689-317.309a1.071,1.071,0,0,1-1.2.921,1.071,1.071,0,0,1-.921-1.2,1.071,1.071,0,0,1,1.2-.921,1.071,1.071,0,0,1,.921,1.2",
    fill: "#d1213d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.192-272.97H469.36v-23.693h20.832v23.693",
    fill: "#fef2d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.464-291.281H472.088v-1.211h15.376v1.211",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.464-287.957H472.088v-1.212h15.376v1.212",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.464-284.634H472.088v-1.211h15.376v1.211",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.464-281.309H472.088v-1.213h15.376v1.213",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.464-277.986H472.088V-279.2h15.376v1.211",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.717-294.738a.939.939,0,0,1-.941.941.94.94,0,0,1-.941-.941.942.942,0,0,1,.941-.941.941.941,0,0,1,.941.941",
    fill: "#d1213d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.413-392.164l-22.468,7.54-8.579-25.555,22.469-7.541,8.577,25.556",
    fill: "#fef2d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.842-410.927l-16.584,5.567-.439-1.307,16.584-5.567.439,1.307",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.045-407.342l-16.583,5.565-.439-1.305,16.583-5.567.439,1.307",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.249-403.756l-16.584,5.565-.439-1.307,16.583-5.565.44,1.307",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.452-400.172l-16.584,5.567-.439-1.308,16.584-5.565.439,1.307",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.654-396.587l-16.583,5.565-.439-1.307,16.583-5.565.439,1.307",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.314-412.214a1.073,1.073,0,0,1-.675,1.357,1.071,1.071,0,0,1-1.356-.675,1.071,1.071,0,0,1,.675-1.357,1.071,1.071,0,0,1,1.356.675",
    fill: "#d1213d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.6-355.991H640.678v-17.924H658.6v17.924",
    fill: "#fef2d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.6-371.1H640.678v-2.817H658.6v2.817",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.126-279.711l-17.755,2.456-2.455-17.756,17.755-2.455,2.455,17.755",
    fill: "#fef2d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.057-294.675,644.3-292.221l-.387-2.791,17.755-2.455.385,2.791",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.87-339.494l-15.979-8.119,8.119-15.979,15.979,8.119-8.119,15.979",
    fill: "#d1213d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.713-352.962l-15.979-8.119,1.276-2.511,15.979,8.119-1.276,2.511",
    fill: "#b0172f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.356-400.807H491.432V-418.73h17.924v17.923",
    fill: "#fef2d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.356-415.914H491.432v-2.816h17.924v2.816",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.881-400.807H514.959V-418.73h17.923v17.923",
    fill: "#fef2d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.881-415.914H514.959v-2.816h17.923v2.816",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.395-298.322h17.923v-17.924H500.395Z",
    fill: "#fef2d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.317-313.429H500.395v-2.817h17.923v2.817",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.02-400.807H467.1V-418.73H485.02v17.923",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.02-415.914H467.1v-2.816H485.02v2.816",
    fill: "#f1eef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.741-276.278h17.922V-294.2H582.741Z",
    fill: "#fef2d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.741-291.383h17.923V-294.2H582.741v2.816",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.079-276.278H625V-294.2H607.079Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.079-291.383H625V-294.2H607.079Z",
    fill: "#f1eef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.836-381.892,494.943-375.9l-5.989-16.892,16.892-5.991,5.991,16.892",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.787-396.13l-16.892,5.991-.941-2.655,16.892-5.991.941,2.655",
    fill: "#f1eef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.571-372.35l-17.439-4.139,4.137-17.439,17.439,4.139-4.137,17.439",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.059-387.048l-17.439-4.137.649-2.741,17.439,4.139-.649,2.74",
    fill: "#f1eef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.729-300.23l-17.439-4.137,4.137-17.439,17.439,4.137-4.137,17.439",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.217-314.927l-17.439-4.137.649-2.741,17.439,4.137-.649,2.741",
    fill: "#f1eef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.02-379.783H467.1v-17.923H485.02v17.923",
    fill: "#fef2d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.02-394.888H467.1v-2.817H485.02v2.817",
    fill: "#f5e4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.685-425.983H445.55a3.642,3.642,0,0,1-3.643-3.643v-1l253.421-1.795v2.8a3.643,3.643,0,0,1-3.643,3.643",
    fill: "#6391e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.041-375.784v14.171l-12.767-6.121a14.082,14.082,0,0,0-1.408,6.121,14.174,14.174,0,0,0,14.175,14.175,14.173,14.173,0,0,0,14.172-14.175,14.171,14.171,0,0,0-14.172-14.171",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.636-363.872v-14.172a14.163,14.163,0,0,0-12.769,8.051l12.769,6.121",
    fill: "#fef2d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.9-410.882l1.887,25.62h4.315v-25.62h-6.2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.8-415.542l1.369,30.28h4.52v-30.28H556.8",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565-402.584l.721,17.323h3.968l.6-17.323H565",
    fill: "#fef2d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.577-408.615l.731,23.353h4.011l.608-23.353h-5.349",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.753-412.938H585.84v-2.912h2.913v2.912",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.753-402.062H585.84v-2.915h2.913v2.915",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.753-391.188H585.84V-394.1h2.913v2.916",
    fill: "#fef2d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.753-380.315H585.84v-2.913h2.913v2.913",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.3-408.824H591.647v-1.223H610.3v1.223",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.893-414.628H591.647v-1.221h30.247v1.221",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.094-411.724H594.052v-1.225h22.043v1.225",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.893-408.824h-7.26v-1.223h7.26v1.223",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.3-398.036H598.861v-1.221H610.3v1.221",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.893-403.839H591.647v-1.223h30.247v1.223",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.094-400.936H591.647v-1.225h24.448v1.225",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.893-398.036h-7.26v-1.221h7.26v1.221",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.3-387.076H591.647V-388.3H610.3v1.224",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.893-392.879H591.647V-394.1h30.247v1.225",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.094-389.979H594.052V-391.2h22.043v1.221",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.893-387.076h-7.26V-388.3h7.26v1.224",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.488-376.2H591.647v-1.224h13.841v1.224",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.893-379.1H591.647v-1.225h30.247v1.225",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.893-376.2H609.823v-1.224h12.071v1.224",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.972-383.228h-9.325v1.223h9.325v-1.223",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.3-383.228v1.223h18.592v-1.223H603.3",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.094-366.63H585.849v-2.341h30.245v2.341",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.5-354.994H585.852v-1.221H604.5v1.221",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.094-360.8H585.852v-1.221h30.243v1.221",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.3-357.894H588.253v-1.224H610.3v1.224",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.094-354.994h-7.261v-1.221h7.261v1.221",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.094-350.847H590.463v-1.224h25.632v1.224",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.268-338.774H530.785v-1.361h17.483v1.361",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.137-345.236H530.785V-346.6h28.352v1.361",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.7-342H533.036v-1.364H553.7V-342",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.331-338.774h6.808v-1.361h-6.808Z",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.107-334.155h24.032v-1.364H535.107Z",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.349-324.826H466.518v-37.407h49.832v37.407",
    fill: "#e0ecff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481-349.538h-9.873v-9.875H481v9.875",
    fill: "#c4dbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.128-345.747H512.9v2.219H471.128v-2.219",
    fill: "#c4dbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.949-349.538h-9.873v-9.875h9.873v9.875",
    fill: "#c4dbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.9-349.538h-9.873v-9.875H512.9v9.875",
    fill: "#c4dbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.192-339.247H471.128v-2.259h19.064v2.259",
    fill: "#c4dbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.9-339.247H493.839v-2.259H512.9v2.259",
    fill: "#c4dbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.54-334.891H471.128v-2.259H501.54v2.259",
    fill: "#c4dbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.743-306.593h40.93V-342.1h-40.93Z",
    fill: "#e0ecff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.529-328.2h17.657v-10.811H567.529Z",
    fill: "#c4dbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.529-324.046h34.313v2.428H567.529v-2.428",
    fill: "#c4dbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.739-328.2h-8.109v-10.811h8.109V-328.2",
    fill: "#c4dbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.837-328.2h-9.475v-10.811h9.475V-328.2",
    fill: "#c4dbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.189-316.929h-15.66V-319.4h15.66v2.473",
    fill: "#c4dbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.843-316.929H586.184V-319.4h15.659v2.473",
    fill: "#c4dbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.509-312.159h-24.98v-2.473h24.98v2.473",
    fill: "#c4dbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.517-335.122,629.8-330.838l2.5-15.111a15.23,15.23,0,0,0-6.783.389,15.328,15.328,0,0,0-10.437,19,15.328,15.328,0,0,0,19,10.435,15.331,15.331,0,0,0,10.436-19",
    fill: "#e0ecff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.718-332.982l14.719-4.284a15.315,15.315,0,0,0-12.219-10.827l-2.5,15.111",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.216-314.037l-.035.349c-.015.221-.075.572-.08.973.025.4-.011.855.059,1.425a16.619,16.619,0,0,0,.287,1.909,20.7,20.7,0,0,0,.56,2.233c.245.78.536,1.6.885,2.425a23.72,23.72,0,0,0,1.217,2.484,27.6,27.6,0,0,0,1.517,2.427,23.989,23.989,0,0,0,1.833,2.2c.331.337.643.692.981,1.008l1.047.887a20.4,20.4,0,0,0,2.12,1.5c.713.417,1.432.736,2.075,1.072.672.265,1.307.464,1.861.667a9.56,9.56,0,0,0,1.483.364l1.307.268-.017.147-1.328-.221a9.6,9.6,0,0,1-1.513-.313c-.568-.181-1.223-.359-1.917-.6-.665-.316-1.413-.615-2.159-1.015a20.257,20.257,0,0,1-2.231-1.456l-1.111-.872c-.361-.311-.695-.661-1.048-1a24.812,24.812,0,0,1-1.975-2.192,28.336,28.336,0,0,1-1.66-2.443,24.054,24.054,0,0,1-1.357-2.523c-.395-.841-.728-1.68-1.016-2.485a22.244,22.244,0,0,1-.677-2.319,17.788,17.788,0,0,1-.38-2.021c-.1-.607-.087-1.189-.123-1.644-.007-.451.039-.767.044-1l.023-.349,1.328.115",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.434-289.249l4.721-2.445-4.479-2.867Z",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.555-354.406l1.228-.167c.364-.083.805-.163,1.317-.289.509-.16,1.1-.287,1.715-.532a19.115,19.115,0,0,0,1.973-.807,22.119,22.119,0,0,0,2.1-1.125l1.064-.677c.341-.256.685-.516,1.033-.776a20.042,20.042,0,0,0,1.968-1.759,17.585,17.585,0,0,0,1.7-2.021,19.115,19.115,0,0,0,1.384-2.161c.373-.744.712-1.479,1-2.189.229-.729.489-1.412.655-2.061.139-.659.265-1.261.377-1.8s.112-1.016.161-1.405c.076-.784.12-1.232.12-1.232l.156,0s-.025.452-.071,1.244c-.032.395-.024.88-.105,1.427s-.195,1.164-.308,1.837c-.14.667-.376,1.371-.58,2.128-.264.736-.583,1.505-.933,2.287a20.037,20.037,0,0,1-1.337,2.284,18.137,18.137,0,0,1-1.679,2.165,20.768,20.768,0,0,1-1.969,1.909l-1.044.853-1.079.752a22.991,22.991,0,0,1-2.149,1.265,20.614,20.614,0,0,1-2.036.931,21.029,21.029,0,0,1-3.24,1.013l-1.225.217-.2-1.319",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.036-372.71l-2.8-4.52-2.516,4.684Z",
    fill: "#a4c3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.961-374.622h-2.592v-73.449h2.592v73.449",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.961-421.419l-1.833,1.829-16.19-16.192,1.828-1.829,16.2,16.192",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.3-433.191H68.171v-8.841H158.3v8.841",
    fill: "#7a553c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.489-394.975h81.55v-8.841h-81.55Z",
    fill: "#7a553c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.793-447.71v5.1h-25.3l-.4-1.835.4-7.1,25.3,3.831",
    fill: "#fcebd9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.493-442.032h26.188v-.624l-26.188-.717v1.341",
    fill: "#d1213d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.493-444.444v-7.1l25.3,3.831v2.128s-8.975-.712-16-.888c-.278-.007-.548-.011-.811-.011-6.47,0-8.485,2.036-8.485,2.036",
    fill: "#f5d9bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.493-452.392l26.188,4.495v.685l-26.188-3.477v-1.7",
    fill: "#d1213d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.625-452.007v9.587a.422.422,0,0,0,.448.388h30.42v-10.36H82.073a.42.42,0,0,0-.448.385",
    fill: "#d1213d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1-448.846v3.264H107.32v-3.264H91.1",
    fill: "#c3c6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.167-448.846l-4.32,3.264H96.56l3.815-3.264H98.167",
    fill: "#dbdfe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.121-448.846,99.6-445.582h2.02l1.886-3.264h-1.381",
    fill: "#dbdfe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.84-447.212a2.045,2.045,0,0,1-2.177,1.88,2.041,2.041,0,0,1-2.173-1.88,2.042,2.042,0,0,1,2.173-1.881,2.046,2.046,0,0,1,2.177,1.881",
    fill: "#c3c6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2-447.212a1.448,1.448,0,0,1-1.541,1.328,1.445,1.445,0,0,1-1.538-1.328,1.447,1.447,0,0,1,1.538-1.331,1.45,1.45,0,0,1,1.541,1.331",
    fill: "#b0172f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.353-453.67v5.1l-24.86-4.184-.4-1.836.4-7.1,24.86,8.017",
    fill: "#fcebd9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.493-452.179l25.744,4.185v-.621l-25.744-4.905v1.341",
    fill: "#8a78bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.353-451.54s-8.535-4.9-15.564-5.075c-.278-.008-.548-.011-.811-.011-6.471,0-8.485,2.035-8.485,2.035v-7.1l24.86,8.017v2.129",
    fill: "#f5d9bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.493-462.538l25.744,8.677v.687l-25.744-7.661v-1.7",
    fill: "#8a78bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.625-462.152v9.587a.422.422,0,0,0,.448.387h30.42v-10.359H82.073a.42.42,0,0,0-.448.385",
    fill: "#8a78bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1-458.991v3.264H107.32v-3.264H91.1",
    fill: "#c3c6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.167-458.991l-4.32,3.264H96.56l3.815-3.264H98.167",
    fill: "#dbdfe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.121-458.991,99.6-455.727h2.02l1.886-3.264h-1.381",
    fill: "#dbdfe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.84-457.359a2.045,2.045,0,0,1-2.177,1.88,2.041,2.041,0,0,1-2.173-1.88,2.042,2.042,0,0,1,2.173-1.88,2.046,2.046,0,0,1,2.177,1.88",
    fill: "#c3c6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2-457.359a1.448,1.448,0,0,1-1.541,1.329,1.445,1.445,0,0,1-1.538-1.329,1.445,1.445,0,0,1,1.538-1.331,1.448,1.448,0,0,1,1.541,1.331",
    fill: "#5d5f99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.171-436.159l90.132-1.452v4.42H68.171v-2.968",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.922-423.478l-4.467,19.821H195.87l-.823-20.568-30.125.747",
    fill: "#294490"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.048-424.224l1.812,1.772,1.632,16.408,8.909.84v1.548H195.87l-.823-20.568",
    fill: "#183178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.994-411.587a1.234,1.234,0,0,0,.719-.212,1.981,1.981,0,0,0,.553-.577,3.363,3.363,0,0,0,.383-.84,5.3,5.3,0,0,0,.2-1.015,4.774,4.774,0,0,0,0-1.015,2.575,2.575,0,0,0-.212-.812,1.4,1.4,0,0,0-.427-.547,1.056,1.056,0,0,0-.653-.2,1.241,1.241,0,0,0-.684.2,1.913,1.913,0,0,0-.544.547,3.488,3.488,0,0,0-.4.812,5.178,5.178,0,0,0-.221,1.015,4.4,4.4,0,0,0-.013,1.015,2.882,2.882,0,0,0,.2.843,1.481,1.481,0,0,0,.432.577,1.042,1.042,0,0,0,.661.212m.684-6.343a2.022,2.022,0,0,1,1.063.285,2.5,2.5,0,0,1,.811.777,3.327,3.327,0,0,1,.487,1.167,4.78,4.78,0,0,1,.083,1.448,5.214,5.214,0,0,1-.352,1.487,4.618,4.618,0,0,1-.723,1.228,3.625,3.625,0,0,1-1.007.839,2.4,2.4,0,0,1-1.176.311,2.029,2.029,0,0,1-1.105-.313,2.606,2.606,0,0,1-.828-.839,3.519,3.519,0,0,1-.457-1.228,4.828,4.828,0,0,1-.035-1.487,5.3,5.3,0,0,1,.4-1.451,4.448,4.448,0,0,1,.741-1.167,3.478,3.478,0,0,1,.979-.775,2.359,2.359,0,0,1,1.124-.283",
    fill: "#f4ebe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.766-417.864l-4.324,7.476h-1.367l3.788-6.449-2.905,0,.084-1.027,4.724,0",
    fill: "#f4ebe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.917-411.531l-.044,1.143h-1.3l.052-1.143h1.289m.152-4.292-.039,1.084h-1.263l.048-1.084h1.253",
    fill: "#f4ebe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.28-415.771l-1.333.873-.715-.873,3.319-2.113-.061,7.5H184.2l.084-5.383",
    fill: "#f4ebe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.32-417.868l.031,1.036-2.443,0-.117,1.365a4.637,4.637,0,0,1,1.436.2,3.219,3.219,0,0,1,1.045.556,2.385,2.385,0,0,1,.649.816,2.491,2.491,0,0,1,.244.987,2.132,2.132,0,0,1-.205,1,2.451,2.451,0,0,1-.613.8,2.892,2.892,0,0,1-.9.529,3.064,3.064,0,0,1-1.072.192,3.155,3.155,0,0,1-1.075-.165,3.712,3.712,0,0,1-.767-.361,2.7,2.7,0,0,1-.619-.523l.719-.767a2.657,2.657,0,0,0,1.172.621,2.084,2.084,0,0,0,1.061-.02,1.539,1.539,0,0,0,.767-.5,1.157,1.157,0,0,0,.279-.8,1.345,1.345,0,0,0-.227-.776,1.479,1.479,0,0,0-.513-.448,1.985,1.985,0,0,0-.611-.208,3.252,3.252,0,0,0-.513-.049l-1.576,0,.327-3.489,3.523.005",
    fill: "#f4ebe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.957-424.2v-.027h1.089l-1.091.027",
    fill: "#5979ba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.87-403.656H183.029l.744-2.8,9.493-.337.691-17.407,1.091-.027.823,20.568",
    fill: "#203a84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.145-403.656h-6.584l1.433-2.449,6.159-.219-1.008,2.668",
    fill: "#203a84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.492-403.816h-.008l.32-1.82.1,0-.411,1.823",
    fill: "#5979ba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.456-403.656l.028-.16h.008l-.036.16",
    fill: "#49435a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.484-403.656h-4.028l.036-.16.411-1.823,5.141-.183-1.56,2.165",
    fill: "#203a84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.009-423.827h0l5.437-.135h0l-5.439.135",
    fill: "#aecdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.044-405.822l3.328-4.621a2.5,2.5,0,0,0,.668-.256,3.625,3.625,0,0,0,1.007-.839,4.618,4.618,0,0,0,.723-1.228,5.214,5.214,0,0,0,.352-1.487.033.033,0,0,0,0-.011l1.856-2.579,2.885,0-3.788,6.449h1.367l4.324-7.476-4.048,0,4.291-5.959,5.439-.135-10.453,17.856-7.951.284",
    fill: "#5469a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.372-410.443l2.751-3.82a.033.033,0,0,1,0,.011,5.214,5.214,0,0,1-.352,1.487,4.618,4.618,0,0,1-.723,1.228,3.625,3.625,0,0,1-1.007.839,2.5,2.5,0,0,1-.668.256",
    fill: "#f6efeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.442-410.388h-1.367l3.788-6.449-2.885,0,.74-1.027,4.048,0-4.324,7.476",
    fill: "#f6efeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.561-403.656h-8.077l1.56-2.165,7.951-.284-1.433,2.449",
    fill: "#4d619d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.84-424.02h0l1.513-.036-1.513.037",
    fill: "#aecdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.153-406.324l3.385-8.961.741-.485-.084,5.383h.625l-1.048,3.935-3.62.129m5.357-6.656.04-4.9-1.356.864,2.645-7,1.513-.037.107,0-2.949,11.08",
    fill: "#5469a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.821-410.388H184.2l.084-5.383-.741.485.656-1.735,1.356-.864-.04,4.9-.689,2.592",
    fill: "#f6efeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.029-403.656h-3.884l1.008-2.668,3.62-.129-.744,2.8",
    fill: "#4d619d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.489-398v3.027h81.55v-4.04L137.489-398",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.442-355.074s7.868-36.432,15.741-45.807c0,0-4.181,44.343-14.779,48.344s-.962-2.537-.962-2.537",
    fill: "#a1a834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.922-353.508s-7.613-9.556-6.533-25.069.311-18.48.311-18.48,16.564,29.421,11.877,43.331l-5.655.219",
    fill: "#c9c94f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3-404.463s-10.921,33.879-3.609,50.948l7.718.007s-.54-38.16-4.109-50.954",
    fill: "#b0b54f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.31-394.358s-13.178,30.075-10.031,41.973l4.771.524s6.834-31.644,5.26-42.5",
    fill: "#c9c94f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.941-351.86a30.273,30.273,0,0,1-11.96-18.568s13.683,11.568,15.6,16.7-3.636,1.867-3.636,1.867",
    fill: "#a1a834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.348-325.053l-6.2-31.155H84.709l-5.132,31.155H68.348",
    fill: "#dbdfe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.561-356.207l-4.916,29.593-7.565.62.268.94H79.576l5.133-31.153H80.561",
    fill: "#c3c6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.627-328.7l-5.585-26.449h5.121l.464,26.449",
    fill: "#e9ecf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.536-138.22h-19.1l1.4-176.076h17.7V-138.22",
    fill: "#7a553c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.857-170.189,81.1-138.072l7,.064-9.2-35.839-6.041,3.657",
    fill: "#ffc92e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.585-175.3,78.9-173.846l9.2,35.839,5.683-1.457-9.2-35.84",
    fill: "#ffd765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.393-172.966v34.959h6.762v-37l-6.762,2.041",
    fill: "#183178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.025-175.008h-5.87v37h5.87v-37",
    fill: "#294490"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7-172.966v34.959h6.762v-37L56.7-172.966",
    fill: "#b0172f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.328-175.008H63.457v37h5.871v-37",
    fill: "#d1213d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9-140.436H66.019l-1.13-23.252H67.9v23.252",
    fill: "#f8f3e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.318-140.241H75.436l-.5-23.052,2.875-.216-.5,23.268",
    fill: "#f8f3e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.338-168.937a1.828,1.828,0,0,1-1.724,1.915,1.828,1.828,0,0,1-1.725-1.915,1.83,1.83,0,0,1,1.725-1.917,1.829,1.829,0,0,1,1.724,1.917",
    fill: "#f8f3e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.462-142.18l-1.818.481-7.017-22.2,2.909-.767,5.926,22.483",
    fill: "#f8f3e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.624-169.852a1.834,1.834,0,0,1-1.181,2.295,1.83,1.83,0,0,1-2.157-1.415,1.826,1.826,0,0,1,1.181-2.291,1.83,1.83,0,0,1,2.158,1.411",
    fill: "#f8f3e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.814-168.772a1.828,1.828,0,0,1-1.724,1.915,1.828,1.828,0,0,1-1.725-1.915,1.829,1.829,0,0,1,1.725-1.916,1.829,1.829,0,0,1,1.724,1.916",
    fill: "#f8f3e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.588-128.374,36.5-325.368H53.284v196.994h-23.7",
    fill: "#7a553c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.778-128.374h69.264v-9.845H44.778Z",
    fill: "#bbafa3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.536-138.22h4.253V-318.342h-4.253Z",
    fill: "#bbafa3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.284-138.22h4.253V-318.342H53.284V-138.22",
    fill: "#bbafa3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.284-190.6h56.5v-11.557h-56.5Z",
    fill: "#bbafa3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.789-313.81h-56.5v-11.559h56.5v11.559",
    fill: "#bbafa3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.284-251.907h56.5v-11.557h-56.5Z",
    fill: "#bbafa3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.517-218.258l2.848,16.232H81.648L84.5-218.258H65.517",
    fill: "#4d4136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.517-218.258l2.848,16.232H81.648L84.5-218.258H65.517",
    fill: "#4d4136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.607-218.258l-1.315,14.821-11.132.245.2,1.165H81.648L84.5-218.258H80.607",
    fill: "#38312a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.161-218.258,70.6-205.027l.624-13.231Z",
    fill: "#6e5e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.517-218.258c-3.67-.852-4.281-3.648-4.017-5.153a3.487,3.487,0,0,1,4.017-2.633s-4.278-5.636,1.155-8.141A6.427,6.427,0,0,1,75-232.15a3.305,3.305,0,0,1,4.146-2.789c3.757.6,3.445,4.355,2.817,5.452,0,0,.985-1.723,2.529-.94s-.025,2.819-1.121,2.973a5.706,5.706,0,0,1,5.793,2.036c2.193,2.973-.788,7.16-4.672,7.16H65.517",
    fill: "#a1a834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.169-225.418a5.706,5.706,0,0,0-5.793-2.036c1.1-.155,2.664-2.192,1.121-2.973s-2.529.94-2.529.94c.517-.9.811-3.6-1.191-4.867,2.04,1.855-.395,6.231-1.855,6.788,0,0,2.928-.765,3.135.931a2.62,2.62,0,0,1-1.568,2.555s3.458.348,2.893,2.507c-.7,2.649-5.158,1.116-5.158,1.116s1.395,2.159-5.644,2.2H84.5c3.885,0,6.865-4.187,4.672-7.16",
    fill: "#92992b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.422-225.786c-1.11-1.472-1.661-5.129,1.855-5.749s1.933,5.309,1.933,5.309,1.907-1.653,3.056-.412-.711,2.9-3.125,3.033c0,0-1.266,4.6-5.207,3.311-1.9-.62-1.544-4.569,1.488-5.492",
    fill: "#abb337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.487-308.129,76.252-279.6l2.255.092,4.269-26.072-4.29-2.549",
    fill: "#294490"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.008-282.775l-1.5-.06-.255,3.236,2.255.092,4.269-26.072-1.161-.691-3.607,23.495",
    fill: "#759ee0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.483-291.749l.056-.224-1.293-.324-.016.232,1.252.316",
    fill: "#759ee0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.108-288.4l.048-.224-1.177-.255-.016.232,1.145.247",
    fill: "#759ee0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3-290.074l.051-.224-1.233-.285-.019.229,1.2.28",
    fill: "#759ee0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.67-293.421l.061-.224L77.382-294l-.02.231,1.308.352",
    fill: "#759ee0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.858-295.1l.064-.224-1.4-.4-.02.236,1.361.387",
    fill: "#759ee0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.114-296.993l-1.465-.447-.016.24,1.413.431.068-.224",
    fill: "#759ee0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.921-286.726l.043-.227-1.117-.224-.016.232,1.09.219",
    fill: "#759ee0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.785-299.155l-.02.24,1.472.475.072-.224-1.524-.491",
    fill: "#759ee0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.612-301.793l.08-.216-1.639-.591-.016.24,1.576.567",
    fill: "#759ee0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.425-300.121l.072-.216-1.576-.539-.02.236,1.524.519",
    fill: "#759ee0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8-303.469l.084-.216-1.7-.643-.016.24,1.628.619",
    fill: "#759ee0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.075-305.357l-1.752-.7-.019.243,1.683.675.088-.216",
    fill: "#759ee0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.761-288.753c-.957-5.312-.064-7.717,1.772-7.8,1.1-.047,1.62.435,1.48,6.121s-2.294,6.987-3.252,1.676M65.519-283.3c-3.008-1.915-5.8-8.823-3.978-9.92,1.732-1.043,3.488,1.951,4.424,4.945.927,2.963,1.05,5.927-.446,4.975m3.448-14.428c-3.563.475-2.258,8.541-2.258,8.541s-2.61-8.661-6.764-4.627,6.764,13.881,6.764,13.881l3.323.595c3.1-10.981,2.494-18.865-1.065-18.391",
    fill: "#ffd765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.708-289.185s-1.445-4.788-3.894-5.581c1.592.633,1.939,3.591,1.939,3.591l0,.008c1.86,3.361,2.782,9.149.77,7.869a10.931,10.931,0,0,1-3.363-4.337l-.016.024s1.756,3.865.327,3.144a43.39,43.39,0,0,0,3.571,3.9,18.549,18.549,0,0,0,2.255-1.241l-1.584-7.379",
    fill: "#ffc92e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.071-294.878a1.771,1.771,0,0,1,.739.108,2.333,2.333,0,0,0-.739-.108",
    fill: "#ffc92e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.554-281.291c1.565-6.244,1.848-11.284,1.021-14.072a6.435,6.435,0,0,1-.04,2.58c-.236.288-.534-.855-.534-.855v0c.04.828.044,1.861.011,3.205-.135,5.685-2.294,6.987-3.252,1.676a14.5,14.5,0,0,1-.163-5.853c-.272.985-.954,2.772-1.106,1.6l0,.108v1.245a22.14,22.14,0,0,0,.219,2.464s-.076-.255-.219-.641v.539l1.085,7.557s1.7.315,2.981.439",
    fill: "#ffc92e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.646-294.766l-.04.143.048-.131Z",
    fill: "#ffc92e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.852-282.006H68.01a32.258,32.258,0,0,0-1.026-6.009c.954,2.8,1.61,5.081,1.868,6.009",
    fill: "#ffb617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.933-280.669l2.123-20.793,1.879.268L74.31-279.4l-1.377-1.273",
    fill: "#b0172f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.987-279.915l.044-16.295,1.843-.336-.646,17.171-1.242-.54",
    fill: "#585a88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.248-282.006l4.393,18.632H78.794l2.135-18.632H63.248",
    fill: "#8a78bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.643-282.006l3.894,18.632h1.544v-18.632H65.643",
    fill: "#a48cdd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.66-263.374H74.2l1.528-18.632h4.33l-3.4,18.632",
    fill: "#7765b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.077-204.354s11.936-99.3,23.88-124.852c0,0-6.344,120.86-22.421,131.766s-1.459-6.915-1.459-6.915",
    fill: "#a1a834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.118-200.089s-11.548-26.048-9.912-68.328.473-50.369.473-50.369,25.127,80.19,18.016,118.1l-8.577.6",
    fill: "#c9c94f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.3-338.971s-16.567,92.337-5.475,138.865l11.707.017S697.718-304.1,692.3-338.971",
    fill: "#b0b54f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.013-311.425s-19.991,81.966-15.217,114.4l7.236,1.429s10.368-86.249,7.981-115.828",
    fill: "#c9c94f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.181-195.6s-13.969-15.683-18.144-50.611c0,0,20.759,31.532,23.659,45.523s-5.515,5.088-5.515,5.088",
    fill: "#a1a834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.282-122.531l-9.412-84.912H708.1l-7.787,84.912H683.282",
    fill: "#dbdfe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.806-207.443l-7.455,80.657-11.477,1.692.408,2.563h17.032l7.787-84.912h-6.295",
    fill: "#c3c6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.74-132.464l-8.472-72.088h7.768l.7,72.088",
    fill: "#e9ecf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.019-473.4c2.4,9.747,3.268,12.685,5.064,12.349s4.121-13.219,4.121-13.219l-9.185.869",
    fill: "#f8f3e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.161-473.4c2.4,9.747,3.268,12.685,5.065,12.349s4.12-13.219,4.12-13.219l-9.185.869",
    fill: "#f8f3e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.5-101.959a5.452,5.452,0,0,0,1.483,4.82s-6.3,6.861-13.721,7.42a17.451,17.451,0,0,1-11.868-3.155s8.9-4.449,10.2-8.158,13.908-.927,13.908-.927",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.983-97.138c1.816,1.128.951,9.031.951,9.031s-18.4,8.572-27.913,7.156-10.145-6.122-7.235-8.016,10.575-4.97,10.575-4.97l2.949-3.684a4.643,4.643,0,0,1,3.387,1.311c1.727,1.521-.4,3.957-.4,3.957a32.489,32.489,0,0,0,8.336-.784,40.8,40.8,0,0,0,9.351-4",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.731-108.7a5.144,5.144,0,0,0,1.405,4.56s-5.964,6.491-12.981,7.015a16.5,16.5,0,0,1-11.224-2.98s8.42-4.209,9.648-7.718,13.152-.876,13.152-.876",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.138-104.145c1.716,1.067.9,8.541.9,8.541s-17.4,8.1-26.4,6.767-9.6-5.788-6.845-7.579,10-4.705,10-4.705l2.793-3.481a4.394,4.394,0,0,1,3.2,1.239c1.628,1.439-.376,3.743-.376,3.743a30.6,30.6,0,0,0,7.877-.743,38.6,38.6,0,0,0,8.849-3.781",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.09-173.764c-3.245-11-3.819-46.34-4.148-58.513s-.655-16.487-1.793-22.657l-29.215-11.741L256.7-250.523s-.649,28.665-.461,35.743.287,40.337,2.408,46.472,2.121,9.435,1.887,16.747c-.212,6.633.932,36.541,1.148,42.056a1.49,1.49,0,0,0,.837,1.295c7.347,3.579,16.619,1.92,19.605,1.239a1.437,1.437,0,0,0,1.124-1.251c.884-7.054,2.305-32.216,2.527-40.036.235-8.256-2.357-12.031-4.008-17.692-1.125-3.845.456-34.753.545-50,3.063,16.959,9.412,51.816,10.305,54.487,1.177,3.537,3.068,8.256,4.008,22.173.837,12.331,1.487,33.181,1.623,37.772a1.47,1.47,0,0,0,.857,1.322c5.376,2.321,14.511.568,17.652-.144a1.462,1.462,0,0,0,1.157-1.356c.231-4.33,1.107-20.806,1.779-36.328.785-18.065-2.357-24.74-5.6-35.735",
    fill: "#fcffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.9-106.923c.079-.017.153-.033.225-.051a1.437,1.437,0,0,0,1.124-1.251c.817-6.521,2.093-28.519,2.456-37.983h0c-.363,9.464-1.639,31.461-2.456,37.983a1.437,1.437,0,0,1-1.124,1.251c-.072.017-.147.033-.225.051",
    fill: "#adc5ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.2-106.059s-.085-60.672-2.432-67.71c-.789-2.365-.917-11.607-.741-22.833h9.84c-.245,8.352-.5,16.881-.5,22.88a41.977,41.977,0,0,0,.4,7.771c1.58,5.419,4.023,9.108,4.023,16.652q0,.508-.015,1.04c-.017.591-.041,1.28-.071,2.053-.363,9.464-1.639,31.461-2.456,37.983a1.437,1.437,0,0,1-1.124,1.251c-.072.017-.147.033-.225.051a41.677,41.677,0,0,1-6.7.864m6.9-98.637-9.9-.057c.376-14.873,1.1-31.065,1.477-39,2.156.213,4.572.335,7.28.335q.45,0,.892,0l.467,27.471c-.019,3.2-.1,7.081-.215,11.26",
    fill: "#f0f3f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.627-100.316l.129-.029a1.507,1.507,0,0,0,.705-.372h0a1.507,1.507,0,0,1-.705.372l-.129.029",
    fill: "#a4bceb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.447-99.2c.919-7.854.928-39.207-1.043-59.473h9.972a73.007,73.007,0,0,1,1.437,15.292c0,1.671-.039,3.449-.121,5.355-.672,15.521-1.548,32-1.779,36.328a1.457,1.457,0,0,1-.452.984,1.507,1.507,0,0,1-.705.372l-.129.029a56.691,56.691,0,0,1-7.18,1.113m-1.192-60.947c-.624-5.944-1.431-10.8-2.448-13.62-1.468-4.06-2.868-12.741-4.1-22.833h9.555c.261,4.156.577,8.161.961,11.735h-3.964v24.719m2.572-44.381-10.04-.057c-.463-4.288-.895-8.671-1.291-12.94h10.836c.125,4.087.285,8.531.495,13",
    fill: "#f0f3f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.781-367.29a167.792,167.792,0,0,0-1.04,37.795l27.648-2.588-8.908-35.207h-17.7",
    fill: "#8a3f24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.493-337.525c-2.2.316-8.052,1.1-11.651,2.517s-6.745,5.033-9.893,15.1c-1.833,5.877-3.24,11.593-4.1,15.332-.607,2.664-3.608,18.927-3.608,18.927l35.072,1.123v-46.705l-5.824-6.292",
    fill: "#8f8894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.493-337.525c-2.2.316-8.052,1.1-11.651,2.517-3.308,1.3-6.232,4.525-9.121,12.835l.329.533c3.109-5.245,7.555-8.772,9.907-9.751a89.422,89.422,0,0,1,9.788-2.505l1.924-2.359-1.176-1.271",
    fill: "#7e7982"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.653-342.87c.945,2.184-.155,6.133-1.1,7.549s-.316,6.6,5.819,7.705,10.22-1.1,12.267-3.617,0-19.343,0-19.343l-5.5-3.351L276.653-342.87",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.4-301.766c-.748-6.491,4.045-18,4.045-18s-2.173,13.471,0,18.6l-4.045-.6",
    fill: "#7e7982"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.818-338.841h0a10.894,10.894,0,0,0,.195-1.841h0a10.9,10.9,0,0,1-.2,1.841",
    fill: "#b9754f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.11-338.193a40.754,40.754,0,0,1-7.292-.648,10.9,10.9,0,0,0,.2-1.841c.185.017.375.027.567.027,2.7,0,6-1.712,9-3.859a15.656,15.656,0,0,0,3.195-3.021,6.307,6.307,0,0,0,2.345,3.916l0,0,.021.015.009.008.012.008.016.011.012.008.016.011.007.005.021.015.008,0a.23.23,0,0,0,.023.015l0,0,.025.016h0a3.334,3.334,0,0,1,1.837,2.861,3.958,3.958,0,0,1-.072.732,26.216,26.216,0,0,1-9.957,1.712",
    fill: "#ecb384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.663-357.528c1.9,4.761-.636,9.841-5.08,13.015s-9.521,5.4-12.381,2.54-6.449-7.7-6.449-10.873-3.707-3.412-2.756-10.077,5.395-11.111,7.935-11.745,17.776,6.349,17.776,6.349l.956,10.792",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.441-373.958c.255,1.456-1.547,6.556-4.539,10.172s.123,7.549-2.06,11.167,3.913,14.783,0,19.028-7.692,4.4-8.792,11.952c0,0-3.3-7.077-.94-12.423s5.032-8.177,2.671-13.053-2.987-12.737-.315-15.569,5.6-9.436,5.395-13.365,7.973-12.739,12.692-9.436l-4.112,11.528",
    fill: "#a0593f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.322-297.735c-2.9,10.543-2.705,16.243-.632,22.96,1.784,5.779,2.761,19.661,3.252,23.544a2.718,2.718,0,0,1-1.407,2.739c-3.152,1.744-11.293,5.071-27.583,5.071-17.277,0-22.705-4.944-24.253-7.1a2.6,2.6,0,0,1-.432-1.889c.436-3.084,1.863-20.927,2.2-24.917.395-4.735,7.3-36.495,7.3-36.495l10.448-16.837,23.085-9.992,9.436,5.019-1.411,37.9",
    fill: "#8f8894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.318-300.7c-.391-1.359-2.041-4.427-4.243-4.348a24.121,24.121,0,0,0-6.213,1.18c-.947.393-2.593,2.835-2.593,2.835l13.049.333",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.139-279.651c-1.191,1.337-3.392,1.416-5.668.789s-3.461-5.633-3.227-6.788,4.181-8.392,4.181-8.392l4.713,14.391",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.013-300.557l9.656,28.772a.774.774,0,0,1-.767,1.021l-27.032-1.173a.777.777,0,0,1-.705-.533L249.9-300.75a.775.775,0,0,1,.757-1.016l26.639.68a.777.777,0,0,1,.715.529",
    fill: "#c3c6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.942-251.231c-.491-3.883-1.468-17.765-3.251-23.544-2.075-6.717-2.268-12.419.631-22.96-1.967-6.279-3.617-19.5-3.617-19.5s-5.668,24.16-4.907,31.575c.761,7.389,1.581,40,1.585,40.168a34.624,34.624,0,0,0,8.152-3,2.718,2.718,0,0,0,1.407-2.739",
    fill: "#7e7982"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.533-299.955l9.661,28.773a.777.777,0,0,1-.772,1.021l-27.032-1.175a.772.772,0,0,1-.7-.532l-9.267-28.28a.777.777,0,0,1,.757-1.016l26.639.679a.774.774,0,0,1,.715.529",
    fill: "#d9dfed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.461-270.159h0m.007,0a.778.778,0,0,0,.757-.657h0a.778.778,0,0,1-.757.657",
    fill: "#a9a7b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.225-270.817a.778.778,0,0,0-.009-.288.779.779,0,0,1,.009.288h0",
    fill: "#c3c6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.527-271.2l-3.137-.136a.772.772,0,0,1-.7-.532l-.385-1.175h0l.385,1.175a.772.772,0,0,0,.7.532l3.137.136h0",
    fill: "#a9a7b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.213-271.115s0-.005,0-.008,0,.005,0,.008m-.005-.021c0-.012-.007-.024-.011-.036,0,.012.008.024.011.036m-10.389-29.348-1.073-.027h0l1.073.028",
    fill: "#c3c6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.461-270.159h-.039l-19.5-.848.577-1.928c3.06.028,6.349.049,9.153.049a61.936,61.936,0,0,0,6.977-.169,32.479,32.479,0,0,0-1.327-5.052c.507-.019,1.029-.041,1.543-.065l.987-.044,2.363,7.036s0,.007,0,.009a.371.371,0,0,1,.011.036l0,.013s0,.005,0,.008,0,.008,0,.011a.779.779,0,0,1,.009.288.778.778,0,0,1-.757.657h-.007m-23.933-1.04-3.137-.136a.772.772,0,0,1-.7-.532l-.385-1.175c1.016.013,2.779.037,4.916.061l-.692,1.783m20.184-13.329s-.419-.007-1.748-.007h-.6c-1.648-5.44-3.523-11.673-4.619-15.979l1.073.028a.774.774,0,0,1,.715.529L281.547-288l1.164,3.472",
    fill: "#ced2e1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.7-284.527c-3.147.093-9.559,1.6-11.825,1.753s-5.249-1.641-6.723-3.377a5.857,5.857,0,0,0-3.729-2.207l1.284,3.831s-.94-.016-4.488,0a8.6,8.6,0,0,1-4.092-1.173c-1.348-.723-2.255-1.447-2.545-1.072-.531.68.528,5.131,1.205,6.113s4.379,1.961,5.884,2.412a23,23,0,0,0,5.169.073c1.487-.068,2.905-.136,3.725-.073,1.971.151,13.556,2.944,19.12,3.472s4.583-6.791,4.583-6.791l-7.568-2.961",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.733-335.635c6.92,2.831,9.125,5.819,11.327,12.58s3.772,30.195,4.244,36.641,0,9.437-1.417,10.065-6.6,2.045-16.2,1.573c0,0,2.2-7.863-2.985-9.752,0,0,5.973-.627,8.175,0a144.467,144.467,0,0,1-5.433-16.173l2.287-34.935",
    fill: "#8f8894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.441-373.958c-.607,4.669,11.449,8.813,16.2,11.873,3.951,2.549-.919,14.969,4.665,18.587s-3.692,8.491,0,14.624-1.18,11.637-1.18,11.637,8.489-2.829,8.651-8.02,2.04-13.211,8.96-10.379c0,0,1.731-8.808-1.727-12.111s-5.5-11.637-3.616-14.153-1.887-14.467-6.449-14.151c-1.961.135-3.573-2.577-5.9-5.289-3.083-3.6-7.421-7.2-15.491-4.147l-4.112,11.528",
    fill: "#a0593f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.614-288.045a2.567,2.567,0,0,1-1.524,3.392,3.113,3.113,0,0,1-3.811-2.068,2.53,2.53,0,0,1,1.919-3.413,3.184,3.184,0,0,1,3.416,2.089",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.531-275.394l-.861-2.637.863,2.636h0",
    fill: "#b8d4fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.749-300.639l-.293-.008.295.008",
    fill: "#d5d7e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.533-275.4l-.863-2.636-.531-1.62L268.318-300.7l2.137.053.293.008-5.495,10.5-.056.008a2.53,2.53,0,0,0-1.919,3.413q.036.1.076.2L257.533-275.4",
    fill: "#e4e9f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.355-286.517q-.04-.1-.076-.2a2.53,2.53,0,0,1,1.919-3.413l.056-.008-1.9,3.625",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.921-271.007l-4.393-.191,4.393.189h0",
    fill: "#b1acb4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.745-300.511l-.671-.017.671.016",
    fill: "#d5d7e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.5-272.937c-1.511-.015-2.967-.029-4.279-.044l4.711-12.145a2.57,2.57,0,0,0,.847-2.183l5.139-13.248,1.159.028.671.017-4.091,13.677a.269.269,0,0,0-.068.061,1.179,1.179,0,0,0-.143.641L267.5-272.937",
    fill: "#e4e9f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.921-271.009l-4.393-.191.692-1.781c1.312.015,2.768.029,4.279.044l-.577,1.928",
    fill: "#dde0ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.443-286.131a1.18,1.18,0,0,1,.143-.641.268.268,0,0,1,.068-.061l-.211.7",
    fill: "#f5d0b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.93-285.126l.847-2.183a2.57,2.57,0,0,1-.847,2.183",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.859-319.762c0,.081,1.669,37.315.908,39.141s-10.011,4.813-14.639,2.847l-.009.025a16.367,16.367,0,0,1-.428,2.973c9.591.472,14.78-.944,16.195-1.573s1.891-3.619,1.417-10.065c-.411-5.633-1.667-24.232-3.444-33.348",
    fill: "#7e7982"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.9-363.786h0c.015-.017.029-.035.043-.053-.013.019-.028.036-.043.053",
    fill: "#bd7d59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.9-363.786a3.219,3.219,0,0,1,.508-.672c-.156.205-.3.42-.465.619-.013.019-.028.036-.043.053",
    fill: "#954c31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.277-343.514l0,0,0,0m-.027-.019-.008,0,.008,0m-.029-.019-.007-.005.007.005m-.023-.016-.012-.008.012.008m-.028-.019-.012-.008.012.008m-.021-.016-.021-.015.021.015m-.025-.017a6.307,6.307,0,0,1-2.345-3.916l0,0a6.3,6.3,0,0,0,2.343,3.919",
    fill: "#bb7954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.778-347.535c-.961-4.143.157-9.816-.939-12.859.02.032.039.064.057.1,1.024,3.071-.063,8.663.884,12.76l0,0",
    fill: "#bd7d59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.122-317.237a11.326,11.326,0,0,0,2.563-6.831,9.209,9.209,0,0,0-1.383-4.807,5.9,5.9,0,0,1-.9-3.117c0-3.307,2.735-6.188,2.733-8.645A3.334,3.334,0,0,0,292.3-343.5h0l-.025-.016,0,0a.135.135,0,0,1-.023-.015l-.008,0a.12.12,0,0,0-.021-.015l-.007-.005-.016-.011-.012-.008-.016-.011-.012-.008-.009-.008-.021-.015,0,0a6.3,6.3,0,0,1-2.343-3.919c-.947-4.1.14-9.689-.884-12.76,2.559,4.5-1.037,11.915,8.424,13.211a5.6,5.6,0,0,0,.761.055c6.228,0,.916-12.427,5.308-14.867a5.088,5.088,0,0,0-.72,2.977c0,3.557,1.78,8.739,4.336,11.176,1.728,1.652,2.16,4.679,2.16,7.293a28.082,28.082,0,0,1-.433,4.817h0a7.087,7.087,0,0,0-2.677-.589c-4.748,0-6.151,6.524-6.283,10.968-.161,5.191-8.651,8.02-8.651,8.02",
    fill: "#954c31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.841-335.366c1.327-4.188-1.608-11.2-1.481-15.255l.012-.041c-.155,4.043,2.8,11.092,1.469,15.3h0",
    fill: "#8a3f24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.807-335.263a0,0,0,0,1,0,0s0,0,0,0m.008-.021c.008-.028.017-.055.025-.081h0c-.008.027-.017.053-.025.081",
    fill: "#845c53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.05-321.639a21.467,21.467,0,0,1-1.792-7.995,10.934,10.934,0,0,1,.852-4.428c1.712-3.885,3.592-6.441,3.588-9.419a8.247,8.247,0,0,0-.917-3.635h0a22.7,22.7,0,0,1-2.032-9.288c.195,4.785,2.951,9.44,5.471,9.44,1.2,0,2.348-1.056,3.14-3.657-.127,4.051,2.808,11.067,1.481,15.255h0c-.008.027-.017.053-.025.081a.077.077,0,0,0-.007.019,0,0,0,0,0,0,0,4.622,4.622,0,0,1-.965,1.672h0c-3.915,4.247-7.692,4.4-8.792,11.952",
    fill: "#954c31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.305-212.374c-1.7,18.137-4.968,32.411-4.687,36.945s3.363,16.049-.035,31.716c-2.335,10.761-6.483,25.508-6.2,34.008s2.549,13.605,2.549,19.841-.561,7.929-8.219,7.935c-8.04.005-5.892-9.32-5.072-13.573s2.539-11.661,2.8-15.336c.655-9.063-1.936-29.84-2.24-35.672-.564-10.824.824-19.283,2.24-27.5.591-3.424-1.279-11.54-2.329-18.811-1.473-10.181-2.44-19.552-2.44-19.552h23.627",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.312-214.939c-6.235,15.869-5.729,32.625-6.293,35.459s-3.8,12.528-7.483,22.732-10.175,41.942-12.441,48.177-5.1,13.321-7.935,15.874-9.353,3.683-9.921,7.083,17.572,2.836,18.14,1.417,1.417-8.5,5.1-10.488,7.653-5.383,5.952-8.785-3.4-4.532-1.417-8.782,9.041-22.98,14.709-29.346,6.632-25.128,10.029-29.948,14.593-28.339,16.577-34.859-25.019-8.535-25.019-8.535",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.571-100.856a100.134,100.134,0,0,0-2.2,17.092h-2.457s.645-7.485-.3-12.587,4.959-4.506,4.959-4.506",
    fill: "#d1213d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.716-81.929c7.657-.006,8.219-1.7,8.219-7.935a33.577,33.577,0,0,0-.533-5.588c.023.272.383,5.583-5.324,5.485-5.86-.1-7.941-2.8-7.433-5.536-.82,4.253-2.965,13.579,5.072,13.573",
    fill: "#d1213d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.48-94.685c3.684-1.983,7.653-5.383,5.952-8.785-.625-1.245-1.243-2.187-1.685-3.089,0,0-7.109,4.721-9.205,9.609s-5.959,9.72-12.873,6.841c-2.563,1.21-5.085,2.439-5.427,4.495-.568,3.4,17.569,2.836,18.137,1.417s1.417-8.5,5.1-10.488",
    fill: "#d1213d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.219-354.594c6.433,3.985,11.807-1.288,11.523-9.241s-8.933-9.669-10.031-6.913-1.492,16.155-1.492,16.155",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.008-359.231a102.231,102.231,0,0,1,.389-10.333,7,7,0,0,1,.313-1.184c.879-2.213,6.619-1.529,9,2.932a6.645,6.645,0,0,1,.493,1.985c.543,6.053-4.184,9.863-10.195,6.6",
    fill: "#7a553c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.476-255.657c-.915,2.5-4.235,3.069-9.065,34.893a266.332,266.332,0,0,0-2.831,33.419s40.455,9.924,56.949,2.216c0,0,3.553-16.3,3.553-30.591,0-30.245,1.477-30.435-5.725-41.563l-42.881,1.625",
    fill: "#8f8894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.067-361s-1.343-6.6.131-11.232c1.683-5.373,6.383-11.685,16.095-11.179S549.067-361,549.067-361",
    fill: "#7a553c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.768-370.447c2.953-7.573,8.547-14.819,19.359-12.435,11.4,2.523,15.481,13.515,14.381,19.932-1.1,6.4-2.968,10.263-3.745,11.4-3.144,4.6-7.031,5.665-8.919,9.4-1.883,3.747-21.076-28.3-21.076-28.3",
    fill: "#7a553c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.752-329.835l-.021-.208-.028-.1-.069-.231-.028-.048-.141-.237-.011-.009a2,2,0,0,0-1.031-.6c-2.475-.757-6.376-1.1-9.289-2.327-2.944-1.716-3.123-7.689-2.857-10.517A35.826,35.826,0,0,1,574.843-352l-.061-.083-14.032,7.707h-3.481s.153.769.287,1.881l-.284.207.317.108c.28,2.581.376,6.659-1.6,7.8a17.507,17.507,0,0,1-6.075,2.413l.029.147v9.052c6.455.532,7.941,11.055,14.284,11.084,5.644.032,15.716-9.4,21.364-11.2.276,0,.552.012.828.016-.015-.129-.021-.249-.033-.375-.027-.268-.047-.532-.059-.783v-.037a30.674,30.674,0,0,1,.427-5.145v-.013l.009-.289,0-.151-.016-.171",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.271-342.287c-.339-.123-.529-.207-.529-.207s-.128.625.529.207",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.016-335.519h-.009a19.14,19.14,0,0,0,.7-3.039,7.836,7.836,0,0,1-.695,3.039",
    fill: "#d6c3bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557-335.5a.167.167,0,0,1,.005-.016h.009l-.008.015H557",
    fill: "#c6b7b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.591-342.158a.139.139,0,0,1-.007-.023h0a.139.139,0,0,1,0,.021m-.1-.287a3.125,3.125,0,0,0-.241-.476l.239-.125c.024.172.047.356.071.552l-.068.049m3.263-1.931h-.721l6.181-3.228c.148-.023.295-.048.441-.075.012.015.023.028.033.044l-5.935,3.259",
    fill: "#d6c3bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.209-347.6l.359-.187.083.112c-.147.027-.293.052-.441.075",
    fill: "#f3d5bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.249-343.8c.008-.108.017-.213.027-.313.056-.6.149-1.375.273-2.224-.1.756-.223,1.6-.3,2.537m-6.565-3.832c-.011-.016-.021-.029-.033-.044l-.083-.112,8.192-4.28-8.076,4.436",
    fill: "#b1805b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.008-335.5l.008-.015a7.836,7.836,0,0,0,.695-3.039,8.534,8.534,0,0,0-.12-3.6.131.131,0,0,0,0-.021h0c-.029-.091-.061-.179-.1-.264l.068-.049c-.024-.2-.047-.38-.071-.552l2.544-1.329h.721l5.935-3.259,8.076-4.436.021-.011.061.081h0a21.609,21.609,0,0,0-1.267,5.465c-.009.064-.017.129-.027.195-.124.849-.217,1.628-.273,2.224-.009.1-.019.205-.027.313a20.036,20.036,0,0,0,.169,5,43.161,43.161,0,0,1-4.311,1.524,87.958,87.958,0,0,1-12.1,1.771",
    fill: "#ecb384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.927-350.522c-1.149,2.149-2.028,5.2-6.172,7.561-4.141,2.4-10.624,5.359-12.523,5.068-1.883-.307-3.415.02-5.508-5.263-2.112-5.283-3.88-7.855-3.3-12.82.593-4.947.239-15.311,6.865-18.057,4.909-2.064,12.007.391,15.244,5,3.245,4.624,3.095,6.131,3.465,12.669,0,0,3.917-3.856,5.239-3.841s2.279,1.04,1.128,3.611-1.736,2.039-2.039,3.4-.657,2.717-1.42,3.1c-.96.472-.98-.427-.98-.427",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.719-375.1s4.731,15.737,15.031,20.412l6.968-11.865-8.356-9.747-13.643,1.2",
    fill: "#7a553c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.733-374.143s-6.972,7.045-12.008,8.4c0,0,2.115-11.368,9.425-15.109l2.583,6.709",
    fill: "#7a553c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.411-376.619c3.556,6.844-.387,15.405-7.824,14.547-7.229-.833-11.519-7.049-13.953-10.459,1.807,4.629,6.381,14.336,14.116,17.845l1.847-3.152c1.245-1.091,2.873-2.381,3.641-2.371,1.315.025,2.279,1.04,1.128,3.611s-1.736,2.039-2.039,3.4-.657,2.717-1.42,3.1c-.96.472-.98-.427-.98-.427-.537,1-1.033,2.209-1.823,3.444a22.223,22.223,0,0,0-.893,4.3c1.924-3.569,5.464-4.251,8.552-8.771.777-1.14,2.647-5,3.745-11.4.657-3.852-.563-9.341-4.1-13.669",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.939-252.473c-.289.612-.611,1.335-.947,2.132,18.579,9.289,33.06,9.655,33.06,9.655s-3.859,44.048-7.673,58.491c9-.417,16.431-.263,22.151-2.933,0,0,3.553-16.3,3.553-30.591,0-30.245,1.477-30.435-5.725-41.563l-38.064,1.44-6.355,3.369",
    fill: "#7e7982"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.268-332.036s-10.423,6.424-14.4,6.437c-5.857.024-13.965-5.259-13.965-5.259l2.392,59.4h27.243l-1.273-60.581",
    fill: "#f8f3e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.691-314.4c1.837-8.263-4.445-8.947-1.953-12.661a10.062,10.062,0,0,1,7.991-4.2,41.55,41.55,0,0,0,9.9-2.356l9.6,21.936,13.151-21.271s11,2.2,15.825,2.537c8.42.593,10.12,6.669,11.949,14.932s4.665,22.735,5.483,26.52c1.468,6.767,1.445,9.8.439,13.84-.889,3.6-4.111,6.277-7.123,7.564h-2.671s-8.423,1.631-10.476,0c-3.6-2.859.437,10.335,1.4,15.177a1.132,1.132,0,0,1-.76,1.309c-4.58,1.536-25.152,7.465-51.04-.051a1.182,1.182,0,0,1-.865-1.255c.657-5.876,3.933-28.835,1.053-38.789-1.077-3.72-3.739-14.975-1.905-23.232",
    fill: "#d1213d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.448-251.078a1.132,1.132,0,0,0,.76-1.309c-.964-4.843-5-18.036-1.4-15.177a4.863,4.863,0,0,0,2.58.689l-6.637-3.911-2.076,13.5s-33.4,3.939-44.487-1.325c-.273,2.827-.511,5.045-.644,6.224a1.182,1.182,0,0,0,.865,1.255c25.888,7.516,46.46,1.587,51.04.051",
    fill: "#b0172f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.379-277.3s7.983-4.423,8.352-5.031-8.352-28.093-8.352-28.093,1.3,23.095,1.425,24.791-1.425,8.333-1.425,8.333",
    fill: "#b0172f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.381-279.4c-2.167.613-8.665,3.269-8.219,5.541s1.605,2.123,1.587,3.072a5.008,5.008,0,0,0,1.031,2.7c.7,1.188,2.4,1.863,3.017,2.845.6.956,1.676,2.837,4.076,1.816s5.825-3.107,6.405-3.987a2.682,2.682,0,0,0-.385-3.2c-.856-.816-.873-2.333-1.421-3.012a8.1,8.1,0,0,1-1.723-2.137c-.32-.841-1.308-1.364-1.465-1.787s-1.153-2.348-2.9-1.859",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.733-330.421s-7.265-1.639-11.132,2.276c-5.883,5.944-7.74,16.333-9.656,29.76-1.084,7.587-2.792,16.344-2.927,19.385s13.571,5.643,13.571,5.643l6.819-26.985a58.491,58.491,0,0,0,2.833-8.229c3.088-10.741.492-21.849.492-21.849",
    fill: "#d1213d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.595-285.251l.5-33.629s-6.131,19.137-9.113,22.672l.315,21.613c2.827.769,5.295,1.239,5.295,1.239l3.005-11.895",
    fill: "#b0172f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.992-297s-7.685-2.143-9.007-3.568c-1.316-1.405-3.693-8.452-2.316-10.665,1.413-2.229,3.528-4.652,4.287-3.407s-.037,1.909-.037,1.909,2.281-2.951,3.3-2.352.228,4.708-.373,6.011,1.6,1.833,2.929,1.795c1.292-.023,5.564-1.795,11.148,4.843,0,0-.468,5.088-2.9,5.967s-6.268.8-7.029-.532",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.317-298.483a14.157,14.157,0,0,1-4.332-2.087h0a14.156,14.156,0,0,0,4.332,2.087h0m-7.064-10.783a3.883,3.883,0,0,1,.4-1.944,3.883,3.883,0,0,0-.4,1.944",
    fill: "#f3cea4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.457-295.89c-1.6,0-3.032-.352-3.465-1.112,0,0-2.349-.655-4.675-1.481a14.156,14.156,0,0,1-4.332-2.087h0c-1.036-1.111-2.729-5.709-2.732-8.7a3.883,3.883,0,0,1,.4-1.944l.016-.025c.587,5.591,8.477,11.745,14.981,11.745a7.547,7.547,0,0,0,6.271-2.947s-.468,5.088-2.9,5.967a10.212,10.212,0,0,1-2.439.525c-.377.036-.756.055-1.125.055",
    fill: "#ecb384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.992-297s-2.777,29.329,11.528,27.12c13.563-2.087-1.6-32.555-1.6-32.555s-2.555,8.509-9.929,5.435",
    fill: "#d1213d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.24-310.082c-2.743-1.643-10.017-3.611-11.86-6.195a34.7,34.7,0,0,0-4.767-5.381c-2.317-2.353-3.184-6.173-5.121-6.128s-.941,4.345.436,5.893,2.644,4.175,1.777,4.336a24.945,24.945,0,0,1-6.369-.256c-1.937-.476-10.693-3.064-11.769-2-1.132,1.127-.131,2.147,1.381,2.908s8.647,2.2,9.112,2.564c.305.229-3.589-.547-6.068-1.237s-4.756-.821-4.636.831c.151,1.973,6.168,3.24,6.309,3.811s1.105,3.144,2.773,3.349c0,0,1.347,2.468,3.008,2.633a17.107,17.107,0,0,1,6.119,1.2c1.761.791,4.6.441,6.863.265.837-.065,7.209,3.976,7.8,4.02,3.131.261,5.012-10.617,5.012-10.617",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.807-94.529c.131,2.663,3.435,5.334,5.72,7.745s2.924,3.94.512,6.988-12.877,3.649-17.008,1.963c-2.792-1.144-5.484-11.492-7.64-12.129s-2.747-.34-3.149-2.454a35.761,35.761,0,0,1,0-6.817l21.565,4.7",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.372-100.525c.335,1.767,1.135,4.006-.787,5.606a8.31,8.31,0,0,1-5.352,2.075c-1.52,0-1.763,2.876-4.159,5.116s-4.953,3.839-10.313,4.317-10.068-.479-10.631-1.041-1.12-5.116,0-6.715,6.235-3.276,7.115-4.237,3.039-3.513,3.6-5.6,20.531.475,20.531.475",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.936-240.818c.767,6.971,3.137,24.625,4.9,41.685,1.427,13.805,4.869,37.393,4.869,41.325s5.832,62,5.832,62-.627,2.119-4.419,1.027c-6.636-1.909-15.987.187-19.043.625s-.712-26.535-4.644-47.933-16.593-79.046-16.593-79.046-.873,44.984,0,55.031,1.309,63.421.873,64.732-6.115,1.747-9.609.437c-1.857-.7-5.685-.345-8.964.007-2.893.309-5.357.62-5.665.21-.655-.873.656-16.157,1.747-24.676s-.571-29.8-1.923-36.348-2.883-29.257-3.319-36.681-.739-42.4-.739-42.4h56.693",
    fill: "#294490"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.956-107.3c-.52,1.4-14.819,6.008-14.573,1.976-.125,2.55-.116,4.325.093,4.6.656.873,11.135-1.529,14.629-.217s9.172.873,9.609-.437,0-54.69-.873-64.732,0-55.031,0-55.031l-1.613-19.685H412.655s.168,38.669,2.012,53.535,4.815,78.589,4.289,79.988",
    fill: "#183178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.122-94.777c3.792,1.092,4.419-1.027,4.419-1.027s-5.832-58.072-5.832-62-3.443-27.524-4.869-41.325c-1.765-17.06-4.136-34.715-4.9-41.685H441.591c1.869,12.663,14,79.168,15.559,86,1.688,7.407,4.833,54.865,4.833,54.865a123.8,123.8,0,0,0-14.3,1.754c.273,2.61.687,4.144,1.4,4.043,3.056-.438,12.407-2.533,19.043-.625",
    fill: "#183178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.155-241.35c-.1-.915-9.739-9.452-9.572-9.657s2.608,1.763,6.053,4.356,4.335,2.908,4.68,1.307-7.795-7.655-9.668-9.5-4.336-4.58-3.815-5.6,2.884.2,5.788.887,4.641-.731,4.811-1.532-4.325-1.832-7.675-3.209-4.821-1.221-7.98-1.241a14.37,14.37,0,0,1-4.711-.856c-1.2-.6-2.383-1.207-3.405-1.812-3.143-1.853-24.881-26.349-24.881-26.349a17.985,17.985,0,0,0-2.984-.5c-7.1-.621-14.829,2.487-16.136,5.712,2.117,3.705,24.817,19.791,33.464,25.392a27.53,27.53,0,0,1,3.824,3.34c1.227,1.381,2.629,1.336,4.5,3.379.149.211.325.4.456.621,1.227,2.057,3.729,6.543,5.476,7.58a24.742,24.742,0,0,1,6.213,5.316c2.544,2.879,5.4,5.557,6.524,4.623.825-.692-2.553-4.632-4.145-6.395,5.06,5.563,8.135,7.68,9.377,6.088.58-.74-8.757-9.383-8.361-9.537s8.461,8.661,10.288,9.4c1.381.556,1.981-.885,1.883-1.808",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.539-362.21c-.936,5.752,4.82,9.467,9.623,11.069s17.6-.641,22.719,7.359,14.719,44.483,17.6,47.363,28.583,26.748,28.583,26.748-1.7,11.651-10.339,15.171c0,0-32.641-27.521-36.161-32.637s-11.2-25.6-11.2-25.6.64,33.675,1.6,40.719,5.712,26.4,2.513,31.205c0,0-32.361,14.639-61.078,0,0,0-2.028-29.568,0-45.043.765-5.848-.565-19.521-.565-19.521s-18.635,21.763-21.513,21.123S354.6-289.346,344.034-296.7c0,0-1.8-10.44,4.2-14.029l22.669,6.7c-.129.991,12.8-16.136,15.06-27.285a19.08,19.08,0,0,1,11.289-13.177c6.353-2.583,12.641-3.519,15.965-7.875s20.321-9.843,20.321-9.843",
    fill: "#523646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.678-383.994c.411,3.525.633,9.659,2.685,12.209s5.823-5.333,5.823-5.333-3.455-7.884-3.915-7.919-4.593,1.043-4.593,1.043",
    fill: "#b38644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.695-353.243c-3.228-2-5.807-4.981-5.156-8.967,0,0-17,5.487-20.321,9.843a10.817,10.817,0,0,1-1.471,1.552l0,.005s3.943,7.039,11.456,6.308,15.515-8.692,15.515-8.692l-.025-.049",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.083-383.334c-1.225,2.125.491,7.584-.153,9.047s-1.18,7.828.889,13,15.269,5.9,15.269,5.9l6.537-3.055,4.179-9.5,2.428-14.428-10.312-6.911-18.837,5.949",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.174-388.446c-1.028,5.269,6.353,11.648,5.4,13.936s-.437,7.829-3.431,12.011-6.319,3.007-6.319,3.007-2.952-4.9-7.365-4.76-3.533,2.544-5.011,3.376a2.179,2.179,0,0,1-2.625-.411,4.093,4.093,0,0,0,.128,3.219c1.069,2.592,3.869,6.183,5.911,8.411,3.453,3.776,9.381.711,11.679-.531s10.023-9.228,10.883-12.363a10.4,10.4,0,0,0-.261-5.969,14.209,14.209,0,0,0,2.381-5.593c.708-3.5,1.959-8.292-.113-12.621s-6.916-7.187-9.823-6.343l-1.429,4.632",
    fill: "#b38644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.1-387.051a4.932,4.932,0,0,1-4.048.483c-2.345-.709-2.995,5.547-10.927,5.925s-13.063-9.379-13.063-9.379,7.148,1.821,9.719-1.624,6.775-7.391,13.939-5.784,5.887,4.352,5.887,4.352l-1.507,6.027",
    fill: "#b38644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.508-371.055c.033-1.052-.216-4.645,1.332-5.071s.131,4.4-.007,6.2.527,3.4-.395,4.143-1.412-.975-1.287-1.779a33.852,33.852,0,0,0,.356-3.493",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.748-362.184a6.77,6.77,0,0,1,5.692,3.709c.375,1.081-1.657,1.3-4.321,1.617-3.084.371-5.407-.767-5.563-1.383a3.64,3.64,0,0,1,4.192-3.944",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.551-323.125s-18.895,32.983-20.976,33.9-29.939-9.723-31.347-10.239l-.411.22c.061,1.483.216,2.54.216,2.54,10.564,7.359,28.407,11.8,31.285,12.445s21.513-21.123,21.513-21.123l-.281-17.743",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.582-290.173c-3.32-5.187-19.221-40.612-19.221-40.612v18.043s7.68,20.483,11.2,25.6S501.721-254.5,501.721-254.5a13.637,13.637,0,0,0,4.9-3.48c-4.7-4.285-30.035-27.491-33.043-32.192",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.986-299.309l0-.145v-.005Z",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.1-297.415c.461,8.889-.181,36.516-7.875,39.04-8.3,2.724-21.728,3.565-26.424,2.523,0,0,4.845,3.729,24.351,2.695,7.575-.4,7.059,2.129,1.648,4.661-8.521,3.988-29.183,7.976-49.52.505-.195-.076-.364-.127-.555-.2.265,4.52.671,7.369.671,7.369,28.717,14.639,61.079,0,61.079,0,3.2-4.8-1.557-24.165-2.517-31.205-.325-2.4-.617-21.549-.857-25.392",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.255-158.676h78.589v-26.192H308.255Z",
    fill: "#7a553c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.844-184.868H308.255v10.315s7.827-6.025,10.349-6.4,68.24-1.32,68.24-1.32v-2.595",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.232-170.6H332.862l14.685,4.143,14.685-4.143",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.232-170.6H332.862l14.685-2.823,14.685,2.823",
    fill: "#8d664a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5-187.472,262.993-71.7h-1.372L242.083-187.472H252.5",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.814-163.934,193.337-81.66h1.045l16.4-82.275h-7.965",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.516-150.014l-9.477,82.27h1.045l16.4-82.27h-7.965",
    fill: "#7a553c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.363-145.8l9.479,82.27h-1.048L194.4-145.8h7.965",
    fill: "#7a553c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.662-159.716l9.479,82.27h-1.048l-16.4-82.27h7.965",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.7-155.924l33.935-8.063h41.644l-21.532,12.1a5.463,5.463,0,0,1-3.081.684l-50.893-3.811a.463.463,0,0,1-.072-.912",
    fill: "#bbafa3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.352-155.382l.416,12.163,51.167,3.127V-151.2l-51.583-4.181",
    fill: "#b0a294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.1-172.876v11.793l-51.169,20.989V-151.2L259.1-172.876",
    fill: "#a39484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.123-85.556c-.332,1.316-1.7,7.316-1.641,8.837.115,2.879.816,5.664,1.647,6.6,1.271,1.434,6.708,3.089,7.623,2.029s2.7-1.854,3.241-.945,4.616,4.822,11.1,5.5,13.393.721,15.959-1.655a5.08,5.08,0,0,0,.775-7.164c-1.483-1.953-18.992-6.8-21-11l-17.695-2.2",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.7-191.136s51.919,16.359,62.943,20.625,17.779,9.955,17.423,16.359-7.465,28.445-7.823,35.2-5.055,38.628-5.651,39.22-17.268,2.235-23.965-2.973c0,0,5.656-37.514,5.656-39.748s-4.912-30.815-4.912-30.815-51.8-23.224-50.017-22.777,6.347-15.091,6.347-15.091",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.177-70.852c1.369,3.708,5.4,7.887,7.255,8.354s7.28-1.24,7.436-2.633,1.179-3.055,2.137-2.613,6.533,1.373,12.264-1.725,11.464-6.969,12.237-10.376A5.076,5.076,0,0,0,341.1-86.2c-2.324-.775-19.517,5.113-23.547,2.788L303.177-70.852",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.518-73.82c-.413-2.576-.833-6.994,1.44-7.488,0,0-.119,1.834,4.094,2.333s9.428.417,11.571-2.663c0,0,2.143-.5,2.473.832s.164,2.248,4.128,3.412,13.548,2.161,13.468,7.977-1.241,5.735-3.965,6.652-10.657,1.995-16.522-.167-5.777-3.826-7.513-2.993S95.343-67,94.93-67.336s-.411-6.484-.411-6.484",
    fill: "#c3c6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.726-62.764c2.378-.8,3.561-.841,3.879-4.708a20.747,20.747,0,0,1-7.455,2.988C116.86-62.8,109.577-66.2,108.1-67.23a6.058,6.058,0,0,0-4.9-1.031,10.857,10.857,0,0,1-8.613-2.057,9.643,9.643,0,0,0,.344,2.983c.413.333,7.022,2.244,8.761,1.412s1.648.832,7.513,2.993,13.8,1.078,16.522.167",
    fill: "#523646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.321-84.383l-.574,4.923s.164,2.139,8.207,2.139,7.554-2.795,7.554-2.795l-.657-7.221-14.53,2.955",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.39-78.12l-.6,5.169s.173,2.237,8.616,2.237,7.925-2.928,7.925-2.928L86.95-82.329,72.39-78.12",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.411-222.241c-3.185,8.529-1.843,15.58.464,25.409s1.011,43.648-.713,48.463-5.406,19.84-3.756,34.388S95-82.481,95-82.481s11.477.057,18.694-3.455c0,0-2.4-42.09-2.086-47.136s4.1-15.223,6.594-21.28,5.375-64.681,5.375-64.681l-29.164-3.208",
    fill: "#294490"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.074-85.649h0m.052-.022.014-.007-.014.007m.053-.024.02-.009-.02.009m.051-.023.034-.016-.034.016m.054-.025.033-.015-.033.015m.058-.027.034-.016-.034.016m.052-.024.041-.019-.041.019m.057-.027.034-.016-.034.016m.06-.028.028-.013-.028.013m.06-.029.018-.008-.018.008m.06-.028.012-.005-.012.005",
    fill: "#3d61ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.822-83.519c-.67-9.012-3.5-48.4-2.193-54.385,1.451-6.665,1.895-29.637,4.541-40.615,3.239-12.955,6.574-27.221,8.154-34.047,2.482.18,4.555.229,6.075.229.3,0,.575,0,.829-.005-.84,15.557-3.053,53.2-5.027,57.989-2.494,6.057-6.279,16.235-6.594,21.28-.02.313-.029.768-.029,1.348,0,8.756,2.115,45.788,2.115,45.788h0l-.049.024-.012.005-.042.02-.018.008-.032.016-.028.013-.027.012-.034.016-.016.008-.041.019-.017.008-.034.016-.024.012-.033.015a.115.115,0,0,1-.02.009l-.034.016-.031.014-.02.009-.039.017-.014.007-.049.021h0a33.311,33.311,0,0,1-7.253,2.131",
    fill: "#203a84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.648-228.326c-4.259,8.9-3.485,16.648-1.936,27.491s-3.1,47.225-5.421,52.261-7.741,20.905-7.354,36.773,1.936,34.455,1.936,34.455S81.26-76.183,89.389-79.28c0,0,1.444-45.681,2.271-51.1s5.886-16.044,9.162-22.344,16.44-63.916,16.44-63.916L81.648-228.326",
    fill: "#294490"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.495-67.008c-.43-2.67-.87-7.244,1.5-7.757,0,0-.125,1.9,4.27,2.417s9.832.432,12.068-2.755c0,0,2.232-.519,2.577.858s.174,2.328,4.307,3.531,14.13,2.242,14.044,8.272-1.292,5.943-4.136,6.894S94.015-53.48,87.9-55.719s-6.024-3.962-7.836-3.1-8.7-1.121-9.137-1.464-.43-6.722-.43-6.722",
    fill: "#dbdfe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.722-301.759c7.317,2.556,9.675,9.265,11.246,19.229s6.511,29.2,6.079,30.349-11.089,5.787-11.089,5.787L123.169-268l3.552-33.761",
    fill: "#e4e7f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.529-77.321h0l.525-.044-.525.044",
    fill: "#847683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.529-77.321c-1.364-13.2,5.231-66.383,8.806-73.861,3.206-6.712,9.187-48.237,11.227-64.167a91.615,91.615,0,0,0,16.761,2.784c-1.58,6.825-4.915,21.092-8.154,34.047-3.05,12.2-6.014,23.232-7.346,25.792-3.276,6.3-8.335,16.927-9.162,22.344-.3,2-.693,9.447-1.061,18.066-.633,14.8-1.21,33.037-1.21,33.037h0a35.9,35.9,0,0,1-9.335,1.915l-.525.042",
    fill: "#203a84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.442-358.724c3.877-1.277,12.659,4.8,14.486,13.655s-3.483,41.7-2.784,47.72c0,0-13.268-1.092-19.04-7.488-1.872-2.072-4.5-5.54-4.5-5.54l3.782-14.424,8.058-33.923",
    fill: "#b1611a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.406-315.342c-2.181,3.288-3.4,9.683-.561,17.684,0,0-6.452-1.473-9.911-4.7s.233-26.092.233-26.092l12.187,3.249-1.948,9.859",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.227-212.341c.223-4.121.349-6.692.349-6.692h0l-13.787-1.516V-309.53c3.09,1.273,6.675,3.207,6.851,3.3.209,1.836.613,3.236,1.294,3.871,2.412,2.251,6.279,3.648,8.4,4.287L123.169-268l6.1,13.468a89.481,89.481,0,0,0-.68,9.263c-.425,12.671-3.347,32.861-3.347,32.861s-.72.049-2.017.065M87.14-227.089a5.83,5.83,0,0,0-2.332-.505H84.7a6.645,6.645,0,0,0-.708.039l-.161-.053a2.444,2.444,0,0,0,1.31-1.857,1.039,1.039,0,0,0-.646-.96h0l-.014-.007a1.734,1.734,0,0,0-.781-.2h-.009a2.286,2.286,0,0,0-1.722,1.139s0,0,0,0l0-.005h0c.023-.041.046-.085.068-.133h0l0-.005,0,0s0,0,0,0a4.327,4.327,0,0,0-.165-3.561c1.785-4.287,3.884-9.423,5.416-13.469l-.156,19.583",
    fill: "#abcffd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.536-221.017l-2.419-.267-14.47-4.747a5.077,5.077,0,0,0-1.508-1.059l.156-19.583c.662-1.748,1.218-3.293,1.6-4.479q.119-.372.228-.757h16.415v30.891m0-42.448H90.56a153.872,153.872,0,0,0-.644-15.673c-.867-10.487-2.729-15.385,1.385-21.685,3.984-6.092,11.842-9.2,14.234-9.741v47.1",
    fill: "#958476"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.789-220.549l-4.253-.468v-30.891h4.253v31.359m0-42.916h-4.253v-47.1c.08-.019.154-.033.221-.045a1.53,1.53,0,0,1,.272-.023,12.441,12.441,0,0,1,3.76,1.1v46.065",
    fill: "#c2c2be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.789-251.907H89.121a47.2,47.2,0,0,0,1.439-11.557h19.229v11.557",
    fill: "#c2c2be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.846-223.719q-.778-.486-1.55-1s.49-1.139,1.264-2.967a5.583,5.583,0,0,1,.735-.052,2.815,2.815,0,0,1,1.005.159,32.18,32.18,0,0,0-1.455,3.86m8.8-2.311h0a5.408,5.408,0,0,0-3.839-1.564,5.829,5.829,0,0,1,2.332.505,5.077,5.077,0,0,1,1.508,1.059M84.7-227.6h0m-.869-.015h0a2.445,2.445,0,0,0,1.31-1.857,2.444,2.444,0,0,1-1.31,1.857m-4.048-.6c.507-1.2,1.115-2.64,1.774-4.22a6.814,6.814,0,0,1-1.774,4.22m2.187-1.283h0m.068-.133h0m0-.007,0,0,0,0m0-.007a4.318,4.318,0,0,0-.168-3.553l0-.008a4.327,4.327,0,0,1,.165,3.561m2.438-.793a1.733,1.733,0,0,0-.781-.2,1.735,1.735,0,0,1,.781.2m-.79-.2h0",
    fill: "#b0bd70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.648-226.03l-4.654-1.527a6.637,6.637,0,0,1,.708-.039h.107a5.408,5.408,0,0,1,3.839,1.564M81.3-227.579a2.815,2.815,0,0,0-1.005-.159,5.586,5.586,0,0,0-.735.052l.223-.525a6.814,6.814,0,0,0,1.774-4.22q.158-.376.319-.763a4.319,4.319,0,0,1,.168,3.553s0,0,0,0l0,0,0,.005h0c-.022.048-.045.092-.068.133h0l0,.005h0s0,0,0,0a2.286,2.286,0,0,1,1.722-1.139H83.7a1.733,1.733,0,0,1,.781.2l.014.007h0a1.039,1.039,0,0,1,.646.96,2.445,2.445,0,0,1-1.31,1.857l-2.184-.716q-.18.374-.347.747",
    fill: "#a6b36a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.711-218.135l-9.593-3.148,2.419.267,4.253.468,13.787,1.516h0l-6.96-.765-3.9,1.663",
    fill: "#5c78b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.4-212.335c-1.521,0-3.594-.049-6.075-.229.594-2.564.94-4.077.94-4.077h0l-4.552-1.493,3.9-1.663,6.96.765s-.126,2.571-.349,6.692c-.254,0-.531.005-.829.005",
    fill: "#5671a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.562-215.349a72.349,72.349,0,0,1-19.716-8.371,32.18,32.18,0,0,1,1.455-3.86q.168-.372.347-.747l2.184.716h0l.161.053,4.654,1.527h0l14.47,4.747,9.593,3.148,4.552,1.493h0l-4.554-1.493c-5.844-.38-12.609-1.6-12.609-1.6-.12,1.063-.3,2.557-.537,4.388",
    fill: "#5c78b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.715-301.693c-.006-.025-.011-.052-.016-.079l.023.012-.007.067",
    fill: "#abcffd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.271-254.53,123.169-268l3.164-30.073c.92.279,1.511.413,1.511.413h0a30.222,30.222,0,0,1-1.13-4.035l.007-.067h0c1.729.908,4.074,9.2,5.869,15.423s4.53,12.12,1.1,19.171c-2.359,4.848-3.687,7.392-4.425,12.636",
    fill: "#dfe9f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.323-212.565a91.616,91.616,0,0,1-16.761-2.784c.234-1.831.417-3.325.537-4.388,0,0,6.765,1.221,12.609,1.6l4.554,1.493s-.346,1.513-.94,4.077",
    fill: "#5671a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.845-297.658s-.591-.135-1.511-.413c-2.12-.639-5.987-2.036-8.4-4.287-.681-.635-1.085-2.035-1.294-3.871l.007,0c5,2.061,8.318,3.549,10.052,4.453.005.027.01.053.016.079a30.221,30.221,0,0,0,1.13,4.035",
    fill: "#e7cbb0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.647-306.225c5.027,2.071,8.347,3.563,10.075,4.465s4.074,9.2,5.869,15.423,4.53,12.12,1.1,19.171-4.68,9.227-5.1,21.9-3.347,32.861-3.347,32.861S99.393-210.651,78.3-224.719c0,0,8.363-19.452,10.6-26.431s1.891-17.5,1.023-27.988-2.729-15.385,1.385-21.685,12.37-9.407,14.455-9.787,10.89,4.385,10.89,4.385",
    fill: "#fcffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.781-314.241h-.009a10.3,10.3,0,0,1,.634-1.1h0a12.064,12.064,0,0,0-.6,1.073l-.026.028",
    fill: "#cd864a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.772-314.241c-.277-.02-7-.535-10.931-3.344.421-4.8,1.057-9.136,1.259-10.433.575-.076.993-.105.993-.105l10.435,7.089-1.123,5.692a10.3,10.3,0,0,0-.634,1.1",
    fill: "#ecb384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.663-236.107c4.068,11.363,11.315,21.788,12.571,26.177s-.113,12.511,3.008,16.787c2.77,3.795,6.485,4.089,6.276,2.7-.228-1.533-1.144-11.027-.672-11.692s3.663,6.039,4.234,4.86-1.718-7.683-2.464-9.549-2.685-2.3-4.246-5.064-5.991-27.585-5.991-27.585l-10.847-3.5-1.87,6.871",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.093-328.123c.32,3.635.872,30.921.872,30.921s-21.454-11.119-23.3-15.769c0,0,5.744-15.223,6.4-21.812,1.117-11.165,7.868-27.767,28.376-23.941l8.837,11.612-10.44,12.98-10.745,6.009",
    fill: "#bd6a22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.277-347.113l-6.657-8.748c3.763,7.816-15.237,10.073-18.324,15.3s-.357,24.016-2.376,27.5-15.354-2.381-15.354-2.381c-.546,1.521-.9,2.467-.9,2.467,1.848,4.651,23.3,15.769,23.3,15.769s-.552-27.287-.872-30.921l10.745-6.009,10.439-12.98",
    fill: "#b1611a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.093-328.123c-1.513,5.783,2.583,10.272,9.313,12.781s11.176-7.232,12.046-10.443.471-5.559,1.941-7.488,1.435-11.673-2.115-13.84-15.344,3.515-17.128,9.149c0,0-3.045-2.983-5.25,1.473-1.206,2.437-.977,8.04,1.193,8.367",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2-275.442c.275,3.995.437,7.928.372,11.607a48.349,48.349,0,0,0,2.312,13.247c1.936,6.215,4.784,14.481,4.784,14.481s7.9-4.671,12.717-3.369c0,0-4.922-16.843-5.276-18.405s4.675-19.5,5.9-25.633c.979-4.893,1.007-17.583-6.63-21.74-1.924-1.049-4.5-2.3-7.335-1.26-2.435.9-4.219,3.369-5.74,5.692-4.117,6.3-2.252,11.2-1.385,21.685.1,1.224.193,2.451.279,3.671v.025",
    fill: "#e4e7f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.62-355.86s4.611,7.445,8.521,6.681c1.389-.271,1.361-1.364.763-2.652-3.452-4.927-8.692-7.807-11.462-6.893l-.659,2.765c1.559.056,2.837.1,2.837.1",
    fill: "#bd6a22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.127-55.547c2.483-.828,3.716-.869,4.048-4.88a21.67,21.67,0,0,1-7.775,3.1c-7.6,1.744-15.2-1.782-16.745-2.851a6.354,6.354,0,0,0-5.106-1.064,11.41,11.41,0,0,1-8.984-2.133,9.958,9.958,0,0,0,.359,3.092c.432.343,7.324,2.324,9.137,1.464s1.72.86,7.836,3.1,14.386,1.116,17.23.172",
    fill: "#523646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.673-169.8c6.047,9.247,9.245,16.715,24.893,17.071s18.848,3.2,33.071,10.311,24.537,11.735,24.537,11.735,30.583,43.03,34.492,48.717,9.916,14.225,13.313,14.225S317.159-78.765,320-84.1c0,0-31.647-39.824-34.492-43.026s-11.736-20.98-17.425-26.673-72.9-42.313-72.9-42.313S175.276-185.8,170.3-181.537s-4.623,11.735-4.623,11.735",
    fill: "#523646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.536-266.781c3.149-4.733,1.691-11.908,1.691-11.908l19.984-2.384s.839,12.229,3.209,16.443-15.885,9.679-24.884-2.151",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.038-248.509c1.093.248.769,1.008,1.125,1.653s-.375,1.811-.489,2.665a3.41,3.41,0,0,1-1.4,2.528c-1.131.968-8.012,2.951-9.045,4.048,0,0-3.443-2.685-3.053-3.192s12.864-7.7,12.864-7.7",
    fill: "#e8ab79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.141-150.014c-9.847-9.2-61.836-20.791-64.843-25.6,0,0-12.741.545-19.455,3.116a17.22,17.22,0,0,0-.171,2.7c6.047,9.247,9.245,16.715,24.893,17.071s18.848,3.2,33.071,10.311,24.537,11.735,24.537,11.735,30.583,43.03,34.492,48.717,9.916,14.225,13.313,14.225c1.772,0,7.425-2.988,12.852-6.6-.005-.011-48.847-66.463-58.691-75.667",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.6-264.809l-23.179,3.891a7.334,7.334,0,0,0-5.929,8.884l18.542,80.308a7.337,7.337,0,0,0,8.311,5.592l15.672-2.523L160.6-264.809",
    fill: "#bbafa3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.492-252.034l18.542,80.308a7.337,7.337,0,0,0,8.311,5.592l13.443-2.167a17.77,17.77,0,0,0-5.577-6.5c-14-10.771-21.115-61.616-28.789-86.113a7.334,7.334,0,0,0-5.929,8.884",
    fill: "#b0a294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.489-232.018c-.641-2.74-1.636-5.872-2.405-6.471l-.421.133c-.677.215-1.383.432-2.119.661l-5.121,1.591-9.263,2.888c-5.984,1.763-12.616,3.488-13.619,2.875-1.523-.931-19.829-26.648-25.179-31.085s-5.579-3.649-19.933-6.572c0,0,12.579,35.377,14.423,37.383S229.533-213.1,231.4-212.838s12-1.733,19.811-6.9c1.432-.945,2.887-1.985,4.331-3.045l.047-.023c3.372-2.389,13.5-5,13.5-5a14.58,14.58,0,0,0-.6-4.211",
    fill: "#ffd765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.7-268.947l9.98,2.551s6.751,16.055,6.924,23.309,4.309,25.024,6.133,28.924,8.321,25.376,8.375,26.46-18.852.56-26.908,6.579-24.964,16.653-27.535,16.055-4.916-11.379-6.223-15.853-2.156-42.58-2.156-42.58,11.021-24.844,11.547-25.229,14.183-12.751,14.183-12.751l5.68-7.464",
    fill: "#ffd765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.2-181.125c8.056-6.019,26.96-5.492,26.908-6.579s-6.549-22.553-8.375-26.46c-1.6-3.42-4.972-17.488-5.9-25.8-1.581-3.083-2.557-4.983-2.557-4.983,2.653,10.233,3.225,37.624-45.3,43.8.368,9.2.867,18.191,1.463,20.225,1.307,4.475,3.649,15.251,6.22,15.853S185.145-175.1,193.2-181.125",
    fill: "#ffc92e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.536-266.781c-4.464,2.143-18.931,6.413-20.731,8.931s-4.043,16.829-5.855,28.949-3.432,27.481-2.317,30.555,6.427,4.727,9.115,5.553,31.771-5.149,33.236-6.917a55.832,55.832,0,0,0-1.555-10.78s-16.345-.119-23.5.793A119.476,119.476,0,0,0,157.29-223.5l25.729-37.98-17.484-5.3",
    fill: "#ffd765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.982-209.2c-19.449-.215-28.245-24.972-28.3-28.811l-.393,12.039.449,16.064,28.243.708",
    fill: "#ffc92e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.684-238.009l0-.48s0,.189,0,.48",
    fill: "#ffc92e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.852-220.642l2.979,19.255s6.568,3.245,12.451-.608l-.968-19.755-14.461,1.108",
    fill: "#f8f3e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.982-222.226c.125.419,1.073,2.489,1.073,2.489l16.063-1.348-.147-3.027-16.989,1.885",
    fill: "#7a553c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.837-225.186l-1.071,2.767,13.619-1.516-1.528-2.567-11.02,1.316",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.826-227.37c-1.145-1.777-1.629-3.028-.247-5.071s-1.181-4.532-1.181-4.532,4.127,2.693,2.532,4.713-2.092,1.971-1.1,4.889",
    fill: "#f8ebe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.889-211.939c.259,3.435-1.288,6.357-3.455,6.519s-4.136-2.491-4.395-5.925,1.288-6.356,3.453-6.517,4.136,2.489,4.4,5.924",
    fill: "#759ee0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.4-262.425c2.685-.451,4.315,2.845,8.636,4.381s7.535,1.476,8.139,0-3.188-7.959-4.308-8.737-9.4.028-11.892.831-4.705,4.219-4.705,4.219l4.131-.693",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.785-217.061c-1.177.237-8.108,5.444-9.257,6.215-1.083.721-3.012.969-5.829,1.52a55.564,55.564,0,0,1,1.061,6.589,41.367,41.367,0,0,1,7.235-1.9c2.115-.105,4.788-1.72,6.653-2.553s5.465,1.323,6.5.847,4.9-3.735,4.407-5.192-9.595-5.755-10.771-5.521",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.838-245.007c3.988-2.319,6.507-4.156,5.261-4.328s-3.131,1.316-9.571,3.859-6.06,4.157-8.923,5.383c-1.255.541-2.969,1.116-4.944,1.739l.421-.133c.769.6,1.764,3.731,2.405,6.471a6.392,6.392,0,0,1,2.112-.827c3.029-.265,5.025.385,8.825-1.149s7.269-1.364,7.241-2.367-3.595-1-5.373-1-2.348-.827-2.424-1.961.977-3.365,4.968-5.688",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.553-202.324c2.551-4.561,8.373-7.373,8.373-7.373A119.477,119.477,0,0,0,157.29-223.5l.389-14.985c-.411,10.281-12.127,36.165-12.127,36.165",
    fill: "#ffc92e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.274-219.8c-1.921-1.344-28.993-25.147-28.993-25.147.931,4.888,4.587,16.724,4.587,16.724,6.717,4.936,22.017,15.175,23.529,15.383,1.868.261,12-1.733,19.811-6.9,1.432-.945,2.887-1.985,4.331-3.045l.047-.023c3.372-2.389,13.5-5,13.5-5a14.58,14.58,0,0,0-.6-4.211s-17.7,6.895-24.092,10.157-10.2,3.408-12.123,2.063",
    fill: "#ffc92e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.232-304.239c.732-7.355-5.908-16.068-20.961-13.037-5.44,1.1-10.515,3.816-11.048,9.037-.029.289-.3.5-.436.756a16.3,16.3,0,0,0-1.481,11.06,30.684,30.684,0,0,0,4.916,11.323c.787,1.177,5.495,3.848,7.625,7.559s21.385-26.7,21.385-26.7",
    fill: "#3b2012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.536-282.645c1.4,2.019,2.04,4.385,6.547,6.341s11.491,4.243,13.405,3.749c1.9-.493,3.523-.337,5.145-5.849s3.169-8.257,2.067-13.169-1.779-15.3-8.889-17.36c-5.261-1.559-12.315,1.648-15.171,6.608-2.876,4.961-2.569,6.448-2.3,13.037,0,0-3.815-3.192-5.159-3.027s-2.247,1.264-.8,3.731,1.395,1.6,1.845,2.931.959,2.637,1.783,2.951a1.863,1.863,0,0,0,1.525.057",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.324-309.646a15.435,15.435,0,0,0-6.965,2.741c-3.324,2.543-7.9,6.191-7.872,10.329s-.075,8.385-.075,8.385l-1.577.167-3.4-13.493,6.243-9.616,13.645,1.487",
    fill: "#3b2012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.1-308.538s5.271.351,7.131,4.3l-3.108-6.585-5.073-2.636,1.051,4.923",
    fill: "#3b2012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.342-289.287c.46,4.851-1.408,4.847-1.253,7.212s.592,4.044,6.193,8,12.345,6.144,15.583,5.127a7.319,7.319,0,0,0,4.707-6.029c.125-1.615.641-8.457.641-8.457a9.01,9.01,0,0,1-4.143,5.071c-3.236,1.737-10.815.825-13.551-1.256s-6.108-8.571-6.108-8.571l-2.481-6.329-1.619,1.868,2.031,3.364",
    fill: "#3b2012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.372-280.773c.452-1.408.855-2.651,1.159-3.835a6.279,6.279,0,0,0-4.284-.029c-2.413.756-2.359,1.151-5.68,3.564-3.576,2.6-5.424,2.965-8.888,1.981-2.529-.717-.161,2.281,1.3,3.953.785.3,1.584.589,2.389.864l4.428-.612.152-2.6c3.491-1.121,3.649-3.132,5.293-4.12,2-1.2,2.756-.493,4.128.837",
    fill: "#3b2012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.792-306.277a8.271,8.271,0,0,0-3.981-2.661c-5.261-1.553-12.315,1.653-15.171,6.608-.335.581-.615,1.1-.868,1.592l.415.637h1.352c2.364-3.017,5.392-5.212,8.545-4.139s6.323.585,8.067-1.553c.613-.745,1.169-.76,1.641-.484",
    fill: "#3b2012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.488-187.472l-12.4,142.757h1.371l21.457-142.757H201.488",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.924-187.472,611.416-63.116h-1.373L590.507-187.472h10.417",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.269-187.472,543.864-72.661h1.369l21.46-114.81H556.269",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.8-184.208H196.617V-196.6H605.8v12.395",
    fill: "#7a553c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.617-196.6l33.161-8.4,391.539,2.261L605.8-196.6H196.617",
    fill: "#966a4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.8-184.208l15.517-6.928v-11.6L605.8-196.6v12.395",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.829-297.635l7.06,80.108H409.326l3.132-80.108H290.829",
    fill: "#dbdfe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.326-217.527H297.889L297.054-227c87.88-3.621,93.942-32.779,100.793-70.631h14.611l-2.072,53-.332,8.485h0l-.728,18.625",
    fill: "#cfd2de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.848-262.7c0,4.237-4.072,7.672-9.093,7.672s-9.093-3.435-9.093-7.672,4.071-7.668,9.093-7.668,9.093,3.435,9.093,7.668",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.607-228.487l6.095,25.109H330.263v2.973H375.84l-19.569-28.083h-9.664",
    fill: "#c3c6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.1-199.854l1.668-45.667h9.711l2.775,45.667H418.1",
    fill: "#f0e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.526-242.19l-8.049-3.331,2.775,45.667h9.436l-4.161-42.336",
    fill: "#d5bff2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.47-203.415h7.007l-3.036-38.043H422.47v38.043",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.6-214.853c-2.417-6.428-7.857-24.587-.075-26.567s6.521,13.729,6.521,13.729,2.581-8.048,6.272-5.435-5.933,10.291-5.933,10.291-.3,6.613-.636,9.117-6.149-1.136-6.149-1.136",
    fill: "#c9c94f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.6-212.839c-1.785,0-5-2.013-5-2.013a78.566,78.566,0,0,1-3.187-10.939q.61.07,1.277.116h0l-.384-2.395a12.026,12.026,0,0,0-1.607-2.048,29.824,29.824,0,0,1-.211-3.391c0-2.72.483-5.064,1.751-6.517.143.093.293.185.451.277h0l.008.009a3.148,3.148,0,0,0,1.788.913h.017c.625,0,1.239-.463,1.517-2.015v-.007c0-.016.007-.033.009-.051s.007-.039.009-.057h0q.052-.318.072-.628c4.428.311,5.011,7.692,5.011,11.567,0,1.389-.076,2.327-.076,2.327h0s1.1-3.423,2.885-5.079l0,.005h0l.015.025c.112.209.881,1.6,1.52,1.639h.027c.381,0,.711-.5.819-2.049h0c.011-.151.019-.3.023-.439a2.831,2.831,0,0,1,.98.463,1.87,1.87,0,0,1,.843,1.605c0,1.265-1.009,2.845-2.247,4.311-.247.136-.508.3-.785.488l-1.611,2.011h0c-1.187,1.119-2.136,1.876-2.136,1.876s-.3,6.613-.636,9.117c-.088.639-.533.877-1.148.877",
    fill: "#bcbf4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.3-228.07c-2.813-4.471-6.772-5.108-7.869-3.244-1.335,2.265.865,5.129,8.253,5.639l-.384-2.395",
    fill: "#c9c94f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.687-225.675a24.876,24.876,0,0,1-2.568-.3c-4.215-.733-6.051-2.412-6.053-4.061a2.5,2.5,0,0,1,.368-1.276,1.854,1.854,0,0,1,.719-.691c.047.051.092.1.137.144l1.971.651h0s-.076-.433-.223-1.029c1.62.275,3.635,1.579,5.265,4.169l.384,2.395",
    fill: "#bcbf4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.932-232.763c-1.444-1.715-2.3-4.947-.968-5.516s3.652.76,3.348,5.131-2.38.385-2.38.385",
    fill: "#c9c94f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.29-231.861c-.856-.841-2.063-3.069-.485-3.716s2.456,4.367,2.456,4.367l-1.971-.651",
    fill: "#c9c94f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.26-231.21l-1.971-.651a4.287,4.287,0,0,1-1.253-2.568,1.157,1.157,0,0,1,.768-1.148.752.752,0,0,1,.281-.057c1.4,0,2.175,4.424,2.175,4.424",
    fill: "#bcbf4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.54-236.654c-.569-1.4.176-4.763,1.772-3.716s-1.015,4.276-1.015,4.276l-.757-.56",
    fill: "#c9c94f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.515-224.71c3.863,0,5.307-1.127,5.468-2.011s-1.045-1.933-3.857,0l-1.611,2.011",
    fill: "#c9c94f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.515-224.71l1.611-2.011a5.074,5.074,0,0,1,2.691-1.092c.8,0,1.18.463,1.181.933a.908.908,0,0,1-.015.159c-.161.884-1.605,2.011-5.468,2.011",
    fill: "#bcbf4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.687-239.749c-4.161-2.441-3.563-5.468-1.392-6.835s5.388,1.689,4.741,5.628-3.349,1.207-3.349,1.207",
    fill: "#c9c94f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.494-238.826h0m.007,0c.625,0,1.239-.463,1.517-2.015-.279,1.552-.892,2.012-1.517,2.015m1.517-2.021c0-.016.007-.033.009-.051,0,.017-.005.035-.009.051",
    fill: "#b6ba4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.494-238.826h-.011a3.148,3.148,0,0,1-1.788-.913l-.008-.009h0a9.459,9.459,0,0,1-1.183-.827c2.685-.6,3.763-5.268,1.477-6.267,1.811.428,3.544,2.9,3.055,5.887h0c0,.019-.005.039-.009.057s-.005.035-.009.051v.007c-.279,1.552-.892,2.011-1.517,2.015h-.007",
    fill: "#bcbf4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.492-231.1h0m0,0c.381,0,.711-.5.819-2.049h0c-.108,1.547-.437,2.048-.819,2.049",
    fill: "#b6ba4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.924-232.774l-.008-.009.008.009m-.009-.011-.008-.009.008.009m-.009-.011a.036.036,0,0,0-.007-.008.036.036,0,0,1,.007.008",
    fill: "#647363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.492-231.1h-.025c-.639-.036-1.408-1.429-1.52-1.639l-.015-.025h0l-.008-.011-.008-.009a0,0,0,0,1,0,0l-.008-.009a0,0,0,0,0,0,0,.036.036,0,0,0-.007-.008,7.51,7.51,0,0,1-1.107-1.932,2.784,2.784,0,0,0,1.832.9c1.005,0,1.628-.969,1.412-2.212a7.946,7.946,0,0,1,.276,2.9h0c-.108,1.547-.437,2.048-.819,2.049h0",
    fill: "#bcbf4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.635-227.025a15.623,15.623,0,0,0,4.769,1.2c-.315-1.421-.669-3.995-.7-4.237a7.58,7.58,0,0,0-3.06-2.019c.02.017,2.5,3.025,1.288,4.256a2.235,2.235,0,0,1-2.293.8",
    fill: "#b0b54f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.687-229.837a4.977,4.977,0,0,1-3.123,1.325c-1.943.185-2.361-.9-2.395-1.8a19.534,19.534,0,0,0-1.1,2.532l-.031.089a48.033,48.033,0,0,1,.339,4.856s4.789-3.829,6.305-7",
    fill: "#b0b54f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.043-227.69s.609-7.739-1.719-11.664c.949,6.767,1.772,17.679-6.632,18.681.665,2.313,1.357,4.371,1.9,5.82,0,0,5.807,3.635,6.149,1.136s.636-9.117.636-9.117l.1-.085.257-6.528a17.911,17.911,0,0,0-.7,1.757",
    fill: "#b0b54f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.288-199.854l-1.635-15.939h17.659L454-199.854H439.288",
    fill: "#dbdfe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.548-215.793l-1.445,9.859-12.3,1.388.481,4.692H454l1.311-15.939h-2.764",
    fill: "#c3c6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.288-199.854l-.367-3.561H454.3l-.3,3.561H439.288",
    fill: "#ffc92e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.249-200.4v-2.436l49.157-3.5v5.933H258.249",
    fill: "#dbdfe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.681-119.264H629.33l-1.788-22.815h9.925l-1.787,22.815",
    fill: "#523646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.33-93.1h6.351v-26.16H629.33Z",
    fill: "#c3c6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.33-70.6h6.351V-93.1H629.33Z",
    fill: "#523646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.657-57.261h-2.6v-8.076a3.97,3.97,0,0,0-3.967-3.964H609.637a3.97,3.97,0,0,0-3.968,3.964v8.076h-2.6v-8.076a6.572,6.572,0,0,1,6.565-6.565h42.451a6.575,6.575,0,0,1,6.569,6.565v8.076",
    fill: "#4d4136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.516-57.261h-2.6v-8.076c0-2.27-1.048-3.964-1.983-3.964H623.249c-.936,0-1.983,1.694-1.983,3.964v8.076h-2.6v-8.076c0-3.684,2.012-6.565,4.58-6.565h16.683c2.572,0,4.584,2.881,4.584,6.565v8.076",
    fill: "#4d4136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.33-104.383l6.351-6.353v-3.928l-6.351,6.355v3.927",
    fill: "#dbdfe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.33-99.312l6.351-6.349v-1.964l-6.351,6.349v1.964",
    fill: "#dbdfe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.681-93.1H629.33v-2.232H633.7v-8.344l1.983-1.981V-93.1m-1.983-12.54v-3.109l1.983-1.983v3.111l-1.983,1.981m0-7.037v-6.583h1.983v4.6l-1.983,1.983",
    fill: "#acb0c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.7-108.753v-3.928l1.983-1.983v3.928l-1.983,1.983",
    fill: "#c1c6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.7-103.68v-1.964l1.983-1.981v1.964L633.7-103.68",
    fill: "#c1c6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.71-139.674l7.095.888L633.7-119.264h1.983l1.788-22.815h-9.927l.168,2.4",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.974-93.1H629.33v.779l4.644.525v19.98h1.707V-93.1h-1.707",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.237-56.864a3.923,3.923,0,0,1-3.636,4.156,3.922,3.922,0,0,1-3.635-4.156,3.924,3.924,0,0,1,3.635-4.159,3.925,3.925,0,0,1,3.636,4.159",
    fill: "#523646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.117-56.864c0,1.317-.655,2.381-1.46,2.381s-1.461-1.064-1.461-2.381.656-2.387,1.461-2.387,1.46,1.068,1.46,2.387",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.97-56.864a3.923,3.923,0,0,1-3.636,4.156,3.924,3.924,0,0,1-3.636-4.156,3.926,3.926,0,0,1,3.636-4.159,3.925,3.925,0,0,1,3.636,4.159",
    fill: "#523646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.974-56.864c0,1.317-.655,2.381-1.459,2.381s-1.461-1.064-1.461-2.381.655-2.387,1.461-2.387,1.459,1.068,1.459,2.387",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.18-56.864a3.92,3.92,0,0,1-3.632,4.156,3.919,3.919,0,0,1-3.635-4.156,3.921,3.921,0,0,1,3.635-4.159,3.922,3.922,0,0,1,3.632,4.159",
    fill: "#523646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.13-56.864c0,1.317-.656,2.381-1.461,2.381s-1.46-1.064-1.46-2.381.655-2.387,1.46-2.387,1.461,1.068,1.461,2.387",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.051-56.864a3.923,3.923,0,0,1-3.635,4.156,3.924,3.924,0,0,1-3.636-4.156,3.926,3.926,0,0,1,3.636-4.159,3.925,3.925,0,0,1,3.635,4.159",
    fill: "#523646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.82-56.864c0,1.317-.655,2.381-1.463,2.381s-1.461-1.064-1.461-2.381.655-2.387,1.461-2.387,1.463,1.068,1.463,2.387",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.43-258.6c8.693,1.163,23.395,3.3,24.287,9.512s3.119,79.784,0,82.116-21.107,6.792-21.581,6.211S640.43-258.6,640.43-258.6",
    fill: "#bbafa3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.717-166.972c3.119-2.331.892-75.9,0-82.114-.357-2.5-2.976-4.339-6.525-5.721,1.421,20.947,6.724,73.948-4.812,79.157s-10.243,14.891-10.243,14.891c.473.581,18.461-3.88,21.58-6.212",
    fill: "#b0a294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.329-153.04c.056,5.453.809,10.619-3.4,12.888s-57.174,5.237-62.676-.892-.344-13.853-.344-13.853l66.424,1.857",
    fill: "#b0a294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.329-153.04c0,3.461-19.5,6.9-39.579,6.9S590.4-148.94,590.4-152.4s16.275-6.267,36.352-6.267,39.579,2.167,39.579,5.631",
    fill: "#bbafa3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.525-158.145c-13.729,3.476-34.181,9.265-18.709,9.433,22.137.245,30.085-2.161,33.071-7.848a136.277,136.277,0,0,0-14.361-1.585",
    fill: "#b0a294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.406-148.552l-.083-.143c-1.136,8.279-56.713,11.149-66.075,7.651,5.5,6.129,58.464,3.161,62.676.892,3.02-1.629,3.477-4.756,3.481-8.4",
    fill: "#a39484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.047-70.736c1.711.479,1.981,3.589,1.96,6.652a5.106,5.106,0,0,1-.672,3.051c-2.507,3.125-6.543,2.729-7.323,2.247-.913-.564-2.821,1.241-4.575,1.892a25.742,25.742,0,0,1-15.8.854c-10.061-2.439-3.279-9,2.877-10.727s23.528-3.968,23.528-3.968",
    fill: "#412332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.961-80.09c-1.792,4.952,1.176,12.181.827,12.638-.263.339-3.563,2.736-11.519,3.641-2.709.3-8.176,2.667-11.523,1.779-9.3-2.46.224-4.735,6.7-7.371a8.362,8.362,0,0,0,4.157-3.257c2.045-2.752.672-10.748.672-10.748l10.683,3.319",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.417-66.113c1.707.478,1.983,3.588,1.956,6.651a5.077,5.077,0,0,1-.672,3.049c-2.508,3.128-6.543,2.732-7.323,2.25-.913-.564-2.817,1.241-4.571,1.891a25.782,25.782,0,0,1-15.8.855c-10.059-2.44-3.279-9,2.881-10.727s23.528-3.968,23.528-3.968",
    fill: "#523646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.327-75.473c-1.792,4.957,1.177,12.185.828,12.643-.259.34-3.559,2.736-11.519,3.639-2.705.307-8.176,2.667-11.523,1.78-9.305-2.463.224-4.739,6.7-7.374a8.341,8.341,0,0,0,4.16-3.252c2.048-2.754.668-10.748.668-10.748l10.683,3.313",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.765-183.314s-.112.879-7.293,1.753-52.336,14.021-56.01,16.283-4.42,11.119-4.225,22.089,2.329,65.273,2.329,65.273a42.4,42.4,0,0,0,18.876.895s1.309-56.148-2.189-65.245l23.96-.892,24.553-40.156",
    fill: "#183178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.85-182.2c3.553,18.621.232,29.972-10.9,31.476s-29.592,3.333-32.125,4.028-18.609,3.536-18.609,3.536.5,49.516-1.629,71.746c0,0-15.584,4.945-20.916-3.023,0,0-1.943-46.415-2.581-63.093s-2.223-20.816,1.172-24.715,32.8-10.239,35.029-12.164,9.817-7.655,9.817-7.655l40.747-.137",
    fill: "#294490"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.214-262.346c3.519,1.555,11.608,15.2,13.621,20.78s4.523,16.889,4.772,29.96.033,34.288.033,34.288-27.757,5.2-43.381-3.885c-2.611-1.516-3.18-16.636-4.548-25.911-2.452-16.549-7.585-37.919-7.585-37.919l6.128-12.82,20.7-4.493h10.261",
    fill: "#d5bff2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.007-282.487c-1.9-4.184,5.82-15.7,16.12-16.021s15.615,3.421,18.087,8.013,6,13.987,16.068,20.667c12,7.957,15.913,20.216,15.913,26.679,0,0-7.812-16.689-15.6-17.829s-7.637-1.367-7.637-1.367a15.916,15.916,0,0,1-3.567,7.8,57.4,57.4,0,0,0-5.919,8.611s-7.529-11.953-5.148-20.405l-28.313-16.144",
    fill: "#b38644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.554-262.347l-.015-.019.015.019m-.028-.035a36.742,36.742,0,0,0-6.409-6.149,36.654,36.654,0,0,1,6.409,6.149m-6.421-6.159-.049-.036.049.036m-.068-.051-.041-.031.041.031m-.067-.049-.032-.024c.011.008.021.015.032.024m-.065-.049a.142.142,0,0,1-.023-.017.142.142,0,0,0,.023.017m-.065-.048-.005,0,.005,0m-1.367-.963a0,0,0,0,1,0,0,0,0,0,0,0,0,0m-.063-.043-.008,0,.008,0m-.065-.043-.064-.043.064.043",
    fill: "#b2bcc7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.309-244.909c-.517-.993-1.249-2.337-2.144-3.827.895,1.488,1.627,2.831,2.147,3.827h0",
    fill: "#c2a4bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.312-244.909c-.52-1-1.252-2.339-2.147-3.827a44.643,44.643,0,0,0-6.631-8.771c-.017-.035-.033-.069-.051-.105-1.748-1.892-3.687-3.3-5.737-3.592l-7.793-1.143a16.982,16.982,0,0,1-3.8,6.841,21.671,21.671,0,0,0-1.663,2.192c-1.365,2.412-2.784,5-4.011,7.352-.008.015-.013.023-.013.023s-4.993-7.927-5.561-15.433a8.923,8.923,0,0,0,.627-3.191,7.532,7.532,0,0,0-.213-1.781s4.255-2.463,4.252-5.884a4.376,4.376,0,0,0-.448-1.9c-.643-1.34-1.48-1.805-2.333-1.805-1.929,0-3.937,2.375-3.937,2.375s-7.983-1.327-13.876-4.941h0l-.329-.2c-1.484-.911-2.709-1.669-3.784-2.276,5.124,2.66,11.312,4.492,16.151,4.492,4.2,0,7.377-1.379,7.963-4.792,1.284-7.443-2.111-14.2-10.152-16.9,6.62.965,10.424,4.041,12.388,7.685,2.469,4.587,6,13.987,16.068,20.667h0l.064.043.057.039.008,0c.02.015.04.028.061.041a0,0,0,0,0,0,0q.7.472,1.361.959l.005,0,.043.031a.142.142,0,0,0,.023.017l.033.025.032.024.025.019.041.031a.1.1,0,0,1,.019.015l.049.036.012.009a36.741,36.741,0,0,1,6.409,6.149l.013.016.015.019a33.665,33.665,0,0,1,7.509,17.361l-.752.077",
    fill: "#a37335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.007-282.487c-1.521,10.449,2.663,11.021,3.041,13.491s-2.468,4.751,3.8,12.16,10.264,7.793,13.112,5.131,9.881-8.375,8.36-14.637c0,0,5.893-3.411,3.8-7.784s-6.271.569-6.271.569-7.983-1.327-13.876-4.941-7.787-4.94-11.971-3.988",
    fill: "#f0bb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.906-261.371h0a8.922,8.922,0,0,0,.627-3.191,8.923,8.923,0,0,1-.627,3.191M594.977-278.5l-.329-.2.329.2",
    fill: "#c68f57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.456-250.209c-2.023,0-4.483-1.261-7.549-4.373.035-.131,4.337-18.128-1.611-26.7,1.212.653,2.595,1.5,4.352,2.576l.329.2h0c5.893,3.615,13.876,4.941,13.876,4.941s2.008-2.375,3.937-2.375c.853,0,1.691.465,2.333,1.805a4.376,4.376,0,0,1,.448,1.9c0,3.421-4.252,5.884-4.252,5.884h0a7.535,7.535,0,0,1,.213,1.781,8.923,8.923,0,0,1-.627,3.191c-1.6,4.193-5.876,7.735-7.947,9.665h0a5.044,5.044,0,0,1-3.5,1.5",
    fill: "#ecb384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.335-239.857c0-2.011-.293-4.587.033-5.259a7.453,7.453,0,0,1,3.9-4.549c2.925-1.3,3.713-2.316,4.779-5.039s.568-3.119-.367-5.4-1.141-4.5-2.6-3.141c0,0-1.348-10.5-2.529-11.048a1.759,1.759,0,0,0-1.8-.065s-.5-1.725-1.812-1.847a1.517,1.517,0,0,0-1.745,1.779s-1.791-.867-2.391.048-.319,3.488-.319,3.488-1.676-.771-1.951,1.313,1.055,9.055,1.008,9.581-4.368,6.035-4.059,11.341.535,11.067.535,11.067l9.313-2.267",
    fill: "#fac396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.746-261.2l-7.793-1.143a16.982,16.982,0,0,1-3.8,6.841,21.683,21.683,0,0,0-1.663,2.192c-3.059,5.4-6.38,11.665-7.22,14.288-1.521,4.752-4.455,12.608-4.455,12.608s-4.561-16.723-5.129-17.1-11.781,4.179-11.781,4.179,1.137,9.883,1.9,15.775,5.36,22.551,5.739,23.124,1.709,2.467,7.031,2.279,12.572-9.12,18.423-16.756c6.345-8.289,13.117-18.163,16.157-24.623s1.715-11.016-1.671-18.071c-1.748-1.892-3.687-3.3-5.737-3.592",
    fill: "#f0e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.768-202.866h0c-.044-.152-.089-.308-.136-.471a0,0,0,0,1,0,0c.047.161.092.319.136.469",
    fill: "#acc0fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.892-202.442c-.04-.136-.083-.277-.125-.424h0l.124.424",
    fill: "#a9847f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.851-198.149c-4.719,0-5.945-1.751-6.307-2.292h0a18.886,18.886,0,0,1-.652-2l-.124-.424c-.044-.151-.089-.308-.136-.469a14.311,14.311,0,0,0,5.641,1.527c2.277,0,4.155-1.072,6.38-3.371,4.065-4.208,23.623-31.976,24.6-39.729s-1.507-16.295-1.507-16.295c2.051.3,3.989,1.7,5.737,3.592,2.069,4.313,3.369,7.695,3.372,11.145a15.93,15.93,0,0,1-1.7,6.925c-3.04,6.46-9.812,16.333-16.157,24.623-5.433,7.092-12.077,15.3-17.257,16.585a5.669,5.669,0,0,1-1.165.171c-.251.009-.492.013-.724.013",
    fill: "#e8dafb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.109-218.063c-.495-2.1-2.292-8.353-2.292-8.353s2.933-7.856,4.455-12.608a56.208,56.208,0,0,1,3.2-6.9l-5.359,27.861",
    fill: "#e8dafb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.016-199.78h18.5L587.565-203H567.911l2.105,3.223",
    fill: "#c3c6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.565-203l-5.608-1.532H569.715l.313,1.532h17.537",
    fill: "#dbdfe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.756-199.78l-9.6-40.9h50.236l9.269,40.9H524.756",
    fill: "#dbdfe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.931-203.3h0l-.155-.655h0l.153.655",
    fill: "#afc4e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.664-199.78H524.756l-.828-3.52h0l.825,3.52h49.908",
    fill: "#ad9891"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.664-199.78H524.756l-.825-3.52-.153-.655c26.324-1.312,38.709-17.821,38.144-36.727h3.473l9.269,40.9",
    fill: "#cfd2de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.219-221.521c0,2.219-2.364,4.015-5.281,4.015s-5.281-1.8-5.281-4.015,2.367-4.019,5.281-4.019,5.281,1.8,5.281,4.019",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.213-184.208H591L611.962-44.714h1.371l-12.12-139.493",
    fill: "#694329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.511-413.076c12.911-3.765,24.943,2.685,28.241,14.007,2.52,8.637-1.429,17.792-9.169,23.323l3.847,6.116-12.072-2.123c-12.912,3.765-25.769-1.389-29.073-12.711s5.316-24.848,18.227-28.612",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.122-342.526l-39.516-8.753-5.3,27.831,15.595,5.913,1.423,9.651,7.445-6.288,8.391,3.183,11.96-31.536",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.554-424.059a13.447,13.447,0,0,0-2.04-1.308,5.53,5.53,0,0,0-1.489-6.909,5.484,5.484,0,0,0-3.541-1.152,16.844,16.844,0,0,0-5.717-8.288,16.941,16.941,0,0,0-23.783,2.888,16.878,16.878,0,0,0-2.687,4.991,11.026,11.026,0,0,0-7.619,4.18,11.073,11.073,0,0,0,1.887,15.544,11.009,11.009,0,0,0,6.752,2.344,11.1,11.1,0,0,0,4.24,9.327,11.12,11.12,0,0,0,15.612-1.9l.124-.175a13.523,13.523,0,0,0,1.695,1.6,13.431,13.431,0,0,0,18.856-2.289,13.433,13.433,0,0,0-2.289-18.856",
    fill: "#fef2d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.5-395.663a3.56,3.56,0,0,1-4,3.057,3.562,3.562,0,0,1-3.057-4,3.563,3.563,0,0,1,4-3.057,3.561,3.561,0,0,1,3.057,4",
    fill: "#fef2d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41-388.087a2.667,2.667,0,0,1-3,2.289,2.668,2.668,0,0,1-2.289-3,2.667,2.667,0,0,1,3-2.289,2.665,2.665,0,0,1,2.289,3",
    fill: "#fef2d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.909-382.4a1.9,1.9,0,0,1-2.135,1.631,1.9,1.9,0,0,1-1.632-2.135,1.9,1.9,0,0,1,2.135-1.631,1.9,1.9,0,0,1,1.632,2.135",
    fill: "#fef2d0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternCommunity);
export default __webpack_public_path__ + "static/media/intern-community.be50012a2d691e48103433847ff6c067.svg";
export { ForwardRef as ReactComponent };